<template>
  <hm-content class="headContainer" :hidden="hidden">
    <div class="mb10">
      订单搜索：
      <el-input
        clearable
        style="width:300px"
        v-model.trim="searchCondition.querySnValue"
        :placeholder="placeholderSnType"
        size="small"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          size="small"
          style="width:100px"
          @change="selectQuerySnType"
          v-model="searchCondition.querySnType"
        >
          <el-option label="订单号" value="receiptSn"></el-option>
          <el-option label="发货单号" value="deliverSn"></el-option>
        </el-select>
      </el-input>
      <el-popover
        placement="top-start"
        width="200"
        trigger="hover"
        v-if="receiptSnHtml !== ''"
      >
        <div v-html="receiptSnHtml"></div>
        <span slot="reference" class="mr10">
          <i class="el-icon-question" style="fontSize:20px"></i>
        </span>
      </el-popover>
      <el-select
        clearable
        v-model="searchCondition.deliveryType"
        placeholder="请选择配送方式"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option label="门店自提" value="mdzt"></el-option>
        <el-option label="快递发货" value="kdfh"></el-option>
        <el-option label="同城配送" value="tcps"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.orderType"
        placeholder="请选择订单类型"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="砍价订单" value="kjdd"></el-option>
        <el-option label="拼团订单" value="ptdd"></el-option>
        <el-option label="秒杀订单" value="mshd"></el-option>
        <el-option label="微店订单" value="wshop"></el-option>
        <el-option label="兑换订单" value="dhdd"></el-option>
        <el-option label="代客下单-当面付" value="smg_faceToFace"></el-option>
        <el-option label="代客下单-网推" value="smg_netPush"></el-option>
        <el-option label="积分兑换订单" value="integral_order"></el-option>
        <el-option label="专享订单" value="exclusive_order"></el-option>
        <el-option label="组合套餐" value="combination_set_order"></el-option>
        <el-option label="接龙订单" value="jielong_order"></el-option>
      </el-select>

      <el-select
        clearable
        v-model="searchCondition.payState"
        placeholder="请选择支付状态"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="未支付" value="no"></el-option>
        <el-option label="已支付" value="yes"></el-option>
      </el-select>

      <el-select
        clearable
        v-model="searchCondition.payMode"
        placeholder="请选择支付方式"
        size="small"
        filterable
        class="mr10"
      >
        <el-option label="微信支付" value="wx_pay"></el-option>
        <el-option label="支付宝支付" value="ali_pay"></el-option>
        <el-option label="0元订单" value="0_pay"></el-option>
      </el-select>
      <el-select
          clearable
          v-model="searchCondition.expressState"
          placeholder="配送状态"
          size="small"
          filterable
          class="mr10"
      >
        <el-option label="待配货" value="daipeihuo"></el-option>
        <el-option label="待发货" value="daifahuo"></el-option>
        <el-option label="挂起" value="guaqi"></el-option>
      </el-select>
      <!-- <el-select
        clearable
        v-model="searchCondition.isOverseas"
        placeholder="请选择是否海外订单"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option label="否" value="no"></el-option>
        <el-option label="是" value="yes"></el-option>
      </el-select> -->
    </div>
    <div class="mb10">
      商品筛选：
      <el-input
        clearable
        style="width:300px"
        v-model.trim="searchCondition.queryGoodsValue"
        :placeholder="placeholderGoodsType"
        size="small"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          size="small"
          style="width:100px"
          @change="selectQuerySnType"
          v-model="searchCondition.queryGoodsType"
        >
          <el-option label="商品名称" value="spuName"></el-option>
          <el-option label="商品货号" value="goodsSn"></el-option>
          <el-option label="商品条码" value="barCode"></el-option>
        </el-select>
      </el-input>
      <el-select
        clearable
        v-model="searchCondition.goodsSource"
        placeholder="请选择商品来源"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option label="自营商品" value="self"></el-option>
        <el-option label="三方发货商品" value="third"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.supplierId"
        placeholder="请选择发货商"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option
          :label="v.supplierName"
          :value="v.supplierId"
          v-for="(v, i) in supplierList"
          :key="i"
        ></el-option>
      </el-select>
      <el-cascader
        v-model="searchCondition.categoryId"
        :show-all-levels="false"
        size="small"
        class="mr10 flex-1"
        :props="categoryFuncs"
        clearable
        placeholder="请选择类目"
      ></el-cascader>
    </div>
    <div class="mb10">
      会员筛选：
      <el-input
        clearable
        style="width:300px"
        v-model.trim="searchCondition.queryMemberValue"
        :placeholder="placeholderMemberType"
        size="small"
        class="ipt mr10"
      >
        <el-select
          slot="prepend"
          size="small"
          style="width:100px"
          @change="selectQuerySnType"
          v-model="searchCondition.queryMemberType"
        >
          <el-option label="会员名称" value="memberName"></el-option>
          <el-option label="会员电话" value="memberMobile"></el-option>
          <el-option label="会员卡号" value="memberCardNo"></el-option>
        </el-select>
      </el-input>
      <el-select
        clearable
        v-model="searchCondition.cardTypeId"
        placeholder="请选择会员类型"
        size="small"
        class="mr10"
        filterable
      >
        <el-option
          :label="v.typeName"
          :value="v.cardTypeId"
          v-for="(v, i) in vipCardTypeList.records"
          :key="i"
        ></el-option>
      </el-select>
      <el-input
        class="mr10"
        style="width:270px"
        clearable
        v-model.trim="searchCondition.shareMemberMobile"
        placeholder="请输入推荐人手机号"
        size="small"
      >
      </el-input>
      <el-input
        class="mr10"
        style="width:270px"
        clearable
        v-model.trim="searchCondition.receiverMobile"
        placeholder="请输入收件人手机号"
        size="small"
      >
      </el-input>
    </div>
    <div class="flex item-center mb10">
      时间筛选：
      <el-select
        v-model="searchCondition.queryTimeType"
        size="small"
        style="width:101px;marginLeft:4px"
        class="time-type"
        filterable
      >
        <el-option label="下单时间" value="purchaseTime"></el-option>
        <el-option label="发货时间" value="sendTime"></el-option>
        <el-option label="付款时间" value="payTime"></el-option>
        <el-option label="退货申请时间" value="returnSendTime"></el-option>
        <el-option label="退货申请审核时间" value="auditTime"></el-option>
        <el-option label="退款时间" value="refundTime"></el-option>
      </el-select>
      <el-date-picker
        v-model="searchCondition.applyDate"
        type="datetimerange"
        align="right"
        start-placeholder="请选择时间段"
        end-placeholder="请选择时间段"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
        class=" mr10 time"
        @change="checkRange"
      ></el-date-picker>
      <!-- value-format="yyyy-MM-dd HH:mm:ss" -->
    </div>
    <div class="">
      订单来源：
      <el-select
        clearable
        v-model="searchCondition.queryOrderSourceType"
        placeholder="请选择订单来源"
        size="small"
        class="mr10 flex-1"
        filterable
      >
        <el-option label="自购" value="selfBuying"></el-option>
        <el-option label="代客下单" value="smg"></el-option>
        <el-option label="分销订单" value="share"></el-option>
      </el-select>
      <el-select
        clearable
        v-model="searchCondition.belongShopId"
        placeholder="搜索/选择门店"
        size="small"
        filterable
        class="mr10 flex-1"
        v-if="storeCode != '53010017032439' && storeCode != '42010216070190' "
      >
        <el-option
          :label="v.shopName"
          :value="v.shopId"
          v-for="(v, i) in shopList.records"
          :key="i"
        ></el-option>
      </el-select>
      <el-select
          clearable
          v-model="searchCondition.belongShopId"
          placeholder="搜索/选择门店"
          size="small"
          filterable
          class="mr10 flex-1"
          v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
      >
        <el-option
            :label="v.shopName"
            :value="v.shopId"
            v-for="(v, i) in dkShops"
            :key="i"
        ></el-option>
      </el-select>

      超出自提时间订单
      <el-checkbox @change="changeMdzt" v-model="searchCondition.mdztIsValid"></el-checkbox>
    </div>

    <div class="flex flex-center mb10">
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="info" size="small" @click="reset">重置</el-button>
      <el-button type="success" size="small" @click="output"
        >生成订单交易信息报表</el-button
      >
      <el-button type="warning" size="small" @click="outputDetail"
        >生成订单综合信息报表</el-button
      >
      <el-button type="danger" size="small" @click="outputPlus" v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
        >生成订单基础信息报表</el-button
      >
      <el-button plain type="primary" size="small" @click="outputDetailPlus" v-if="storeCode === '53010017032439' || storeCode === '42010216070190' "
        >生成商品订单明细报表</el-button
      >
      <!-- <el-button
        type="success"
        size="small"
        @click="output"
        :loading="isOutputing"
        >导出订单</el-button
      > -->
      <!-- <el-button
        type="success"
        size="small"
        @click="outputDetailOrder"
        :loading="isOutputing"
        >导出订单明细</el-button
      > -->
    </div>
    <div style="fontSize:17px;fontWeight:600">
      <span class="mr20">应付金额:{{ payPrice }}</span>
      <span>已付金额:{{ actuallyPrice }}</span>
    </div>
    <el-radio-group
      v-model="searchCondition.orderState"
      size="small"
      @change="switchTab"
    >
      <el-radio-button label="payOrder"
        >待发货({{ orNum.dFHNum }})</el-radio-button
      >
      <el-radio-button label="deliverOrder"
        >已发货({{ orNum.yFHNum }})</el-radio-button
      >

      <el-radio-button label="takeOrder"
        >已收货({{ orNum.ySHNum }})</el-radio-button
      >

      <el-radio-button label="createOrder"
        >待付款({{ orNum.dFKNum }})</el-radio-button
      >
      <el-radio-button label="">全部({{ orNum.allNum }})</el-radio-button>
      <el-radio-button label="returnOrder"
        >有退货退款({{ orNum.returnOrderNum }})</el-radio-button
      >
    </el-radio-group>
    <div class="table">
      <div class="modal-table mb20">
        <div class="flex flex-wrap">
          <div class="table-header  flex " style="width:70%">
            <div class="flex flex-wrap table-header table-p10 not-bder flex-5">
              <div class="flex-5">商品</div>
              <div class="flex-1">单价</div>
              <div class="flex-1">数量</div>
              <div class="" style="width:200px">优惠价</div>
              <div class="flex-2">商品备注</div>
            </div>
            <div class="flex-1 p10">发货信息</div>
          </div>
          <div
            class="table-header not-bder flex table-p10"
            style="width:30%;boxSizing: border-box;"
          >
            <div class="flex-1">支付信息</div>
            <div class="flex-2">收货信息</div>
          </div>
        </div>
        <div style="height:700px">
          <el-scrollbar class="page-component__scroll">
            <div class="order-bder" v-for="(v, i) in list" :key="i">
              <div class="flex flex-between item-center order-info">
                <div>
                  <!-- <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.isOverseas === 'yes'"
                    >海外购</el-tag
                  > -->
                  订单号：{{ v.receiptSn }}
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.shareMemberName !== null"
                    >分销订单</el-tag
                  >
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.packageNum > 1"
                    >有拆单</el-tag
                  >
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.orderType === 'dhdd'"
                    >兑换订单</el-tag
                  >
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.orderType === 'integral_order'"
                    >积分兑换订单</el-tag
                  >
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.orderType === 'exclusive_order'"
                    >专享订单</el-tag
                  >
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.orderType === 'combination_set_order'"
                    >组合套餐</el-tag
                  >
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.orderType === 'jielong_order'"
                    >接龙订单</el-tag
                  >
                  <!-- <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.orderType === 'exclusive_order'"
                    >专享订单</el-tag
                  > -->
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.orderType === 'smg_faceToFace'"
                    >代客下单-当面付</el-tag
                  >
                  <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.orderType === 'smg_netPush'"
                    >代客下单-网推</el-tag
                  >
                  <!-- <el-tag
                    size="mini"
                    effect="plain"
                    color="#FFEEF6"
                    v-if="v.packageNum > 1"
                    >有拆单</el-tag
                  > -->

                  <span class="ml20">下单时间：{{ v.purchaseTime }} </span>
                  <span class="ml20" v-if="v.sourceAppName">下单小程序：{{ v.sourceAppName }}</span>
                  <span class="ml20">接单门店：{{ v.shopName }}</span>
                  <span class="ml20"
                    >会员信息：{{ v.memberName }}
                    <span v-if="v.nickName">({{ v.nickName }})</span> /{{
                      v.memberMobile
                    }}</span
                  >
                  <span
                    class="ml20"
                    v-if="v.shareMemberName || v.shareMemberMobile"
                    >推荐人：{{ v.shareMemberName }}/{{
                      v.shareMemberMobile
                    }}</span
                  >
                  <!-- <span v-for="(z, y) in v.expressModelList[0].goodsList" :key="y"> -->
                  <el-tag
                  class="ml20"
                  size="mini"
                  effect="plain"
                  color="#FFEEF6"
                  v-if="v.isMessageJson"
                  >有留言</el-tag>
                  <!-- </span> -->
                </div>
                <div>共计：{{ v.totalGoodsNum }}件</div>
              </div>
              <div class="flex flex-wrap">
                <div style="width:70%" class="bd-right">
                  <div>
                    <div
                      v-for="(o, n) in v.expressModelList"
                      :key="n"
                      class="flex flex-wrap table-body"
                    >
                      <div class="flex-5">
                        <div
                          class="flex bd-goodsinfo table-p10"
                          style="position: relative;"
                          v-for="(j, k) in o.goodsList"
                          :key="k"
                        >
                          <div class="flex-5">
                            <div class="flex flex-around">
                              <div
                                class="flex flex-center item-center"
                                style="marginRight:5px"
                              >
                                <!-- 换货中 -->
                                <img
                                    class="table-only-tuikuan p10"
                                    v-if="j.changeStatus === 'auditWait' || j.changeStatus === 'changeWait' || j.changeStatus === 'changeDo'"
                                    style="width:100px;height:100px"
                                    src="https://imgcdn.hemiao100.com/hemiaoBase/%E6%8D%A2%E8%B4%A7%402x.png"
                                    alt=""
                                />
                                <!-- 仅退款 -->
                                <img
                                  class="table-only-tuikuan p10"
                                  v-if="j.refundReturnType === 'money'"
                                  style="width:100px;height:100px"
                                  src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                                  alt=""
                                />
                                <!-- 退货退款 -->
                                <img
                                  class="table-only-tuikuan p10"
                                  v-if="j.refundReturnType === 'refund'"
                                  style="width:100px;height:100px"
                                  src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                                  alt=""
                                />

                                <!-- 退运费 -->
                                <img
                                  class="table-only-tuikuan p10"
                                  v-if="j.refundReturnType === 'deliver'"
                                  style="width:100px;height:100px"
                                  src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                                  alt=""
                                />
                                <!-- 已退款 -->
                                <img
                                  class="warning-tuikuan"
                                  v-show="j.returnType === 'yes'"
                                  src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                                  alt=""
                                />
                                <!-- 退款中 -->
                                <img
                                  class="warning-tuikuan"
                                  v-show="j.returnType === 'doing'"
                                  src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                                  alt=""
                                />
                                <div>
                                  <el-image
                                    style="width: 100px; height: 100px"
                                    :src="j.goodsImg"
                                  >
                                  </el-image>
                                  <div style="width:100%">
                                    <el-tag
                                      style="width:100%"
                                      size="mini"
                                      effect="plain"
                                      type="success"
                                      v-if="j.isGift === 'gift'"
                                      >赠 品</el-tag
                                    >
                                    <el-tag
                                      style="width:100%"
                                      size="mini"
                                      effect="plain"
                                      type="success"
                                      v-if="j.isGift === 'markup'"
                                      >加价购商品</el-tag
                                    >
                                  </div>
                                </div>
                              </div>

                              <div
                                class="flex-1 flex flex-column flex-between"
                                style="minHeight: 160px;"
                              >
                                <el-tooltip
                                  class="item"
                                  effect="dark"
                                  :content="j.spuName"
                                  placement="top-start"
                                >
                                  <div
                                    class="flex flex-start threeLine "
                                    style="textAlign:left;max-height:48px"
                                    v-if="j.isOverseas === 'yes'"
                                  >
                                    <el-tag
                                      size="mini"
                                      effect="plain"
                                      color="#FFEEF6"
                                      >海外购</el-tag
                                    >

                                    &nbsp {{ j.spuName }}
                                  </div>
                                  <div
                                    v-else
                                    class="flex flex-start threeLine "
                                    style="textAlign:left;max-height:48px"
                                  >
                                    <el-tag
                                      size="mini"
                                      effect="plain"
                                      color="#FFEEF6"
                                      v-if="!!j.supplierId"
                                      >三方</el-tag
                                    >
                                    <el-tag
                                      size="mini"
                                      effect="plain"
                                      color="#FFEEF6"
                                      v-else
                                      >自营</el-tag
                                    >
                                    &nbsp {{ j.spuName }}
                                  </div>
                                </el-tooltip>
                                <div class=" text-left">
                                  品牌：{{ j.brandName }}
                                </div>
                                <div class=" text-left">
                                  货号：{{ j.goodsSn }}
                                </div>
                                <div class=" text-left">
                                  条码：{{ j.barCode }}
                                </div>
                                <div class="flex flex-between">
                                  <div>规格：{{ j.specIdGroupName }}</div>
                                  <!-- <div class="blue">
                              <span class="hmicon icon-tuikuan"></span>
                              退款
                            </div> -->
                                </div>
                                <div class="text-left" v-if="!!j.supplierId">
                                  发货商：{{ j.supplierName }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-1 flex flex-center item-center ">
                            ￥{{ j.totalPrice }}
                          </div>
                          <div class="flex-1 flex flex-center item-center">
                            {{ j.goodsNum }}
                          </div>
                          <div
                            class="flex item-center flex-center"
                            style="width:200px"
                          >
                            <div>
                              ￥{{
                                ToFixed(
                                  j.realPrice * 1 + j.prepayCardMoney || 0,
                                  2
                                )
                              }}
                              <br />
                              <div v-if="j.promotionInfos">
                                <div
                                  v-for="(promotion, index) in j.promotionInfos"
                                  :key="index"
                                >
                                  <el-tag
                                    size="mini"
                                    effect="plain"
                                    color="#FFEEF6"
                                    v-if="
                                      promotion.promotionCode ===
                                        'IncreasePurchase-NumIncrease' ||
                                        promotion.promotionCode ===
                                          'IncreasePurchase-PriceIncrease'
                                    "
                                    >加价购</el-tag
                                  >
                                  <el-tag
                                    size="mini"
                                    effect="plain"
                                    color="#FFEEF6"
                                    v-if="
                                      promotion.promotionCode ===
                                        'FullReduction-NumReduction' ||
                                        promotion.promotionCode ===
                                          'FullReduction-PriceReduction'
                                    "
                                    >满减</el-tag
                                  >
                                  <el-tag
                                    size="mini"
                                    effect="plain"
                                    color="#FFEEF6"
                                    v-if="
                                      promotion.promotionCode ===
                                        'SpecialPrice-SpecialPrice'
                                    "
                                    >特价</el-tag
                                  >
                                  <el-tag
                                    size="mini"
                                    effect="plain"
                                    color="#FFEEF6"
                                    v-if="
                                      promotion.promotionCode ===
                                        'FullDiscount-NumDiscount' ||
                                        promotion.promotionCode ===
                                          'FullDiscount-PriceDiscount'
                                    "
                                    >满折</el-tag
                                  >
                                  <el-tag
                                    size="mini"
                                    effect="plain"
                                    color="#FFEEF6"
                                    v-if="
                                      promotion.promotionCode ===
                                        'FullDelivery-NumDelivery' ||
                                        promotion.promotionCode ===
                                          'FullDelivery-PriceDelivery' ||
                                        promotion.promotionCode ===
                                          'FullDeliveryOverlay-NumDeliveryOverlay' ||
                                        promotion.promotionCode ===
                                          'FullDeliveryOverlay-PriceDeliveryOverlay'
                                    "
                                    >满送</el-tag
                                  >
                                  <el-tag
                                    size="mini"
                                    effect="plain"
                                    color="#FFEEF6"
                                    v-if="
                                      promotion.promotionCode ===
                                        'CombinationPrice-packagePrice'
                                    "
                                    >组合价</el-tag
                                  >
                                  <el-tag
                                    size="mini"
                                    effect="plain"
                                    color="#FFEEF6"
                                    v-if="
                                      promotion.promotionCode ===
                                        'SuperpositionGift-NumSuperposition'
                                    "
                                    >叠加赠送</el-tag
                                  >
                                  {{ promotion.promotionName }}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="flex-2">
                              <el-input
                              @blur="remarkBlur(j)"
                              @focus="remarkFocus(j)"
                              :style="'height:'+(j.remark?'47.5%':'100%')"
                              class="remark-tarea"
                              size="small"
                              type="textarea"
                              clearable
                              placeholder="请输入商品备注"
                              maxlength="128"
                              v-model="j.operMemo"
                            ></el-input>
                            <el-input
                              style="height:47.5%;margin-top:5%"
                              class="remark-tarea"
                              size="small"
                              type="textarea"
                              v-if="j.remark"
                              :disabled='true'
                              clearable
                              placeholder="请输入订单备注"
                              maxlength="128"
                              v-model="j.remark"
                            ></el-input>
                          </div>
                        </div>
                      </div>

                      <div class="flex-1 text-left bd-bottom p10">
                        <div class="mb10">
                          <el-tag
                            size="mini"
                            effect="plain"
                            color="#FFEEF6"
                            v-if="o.expressState === 'waitAllocation'"
                            >待配货</el-tag
                          >
                          <el-tag
                            size="mini"
                            effect="plain"
                            color="#FFEEF6"
                            v-if="o.expressState === 'waitDeliver'"
                            >待发货</el-tag
                          >
                          <el-tag
                            size="mini"
                            effect="plain"
                            color="#FFEEF6"
                            v-if="o.expressState === 'alreadyDeliver'"
                            >已发货</el-tag
                          >
                        </div>
                        <div
                          class="mb10"
                          v-if="o.expressState === 'alreadyDeliver'"
                        >
                          发货门店：{{ o.sendShopName }}
                        </div>
                        <div v-if="o.expressState === 'alreadyDeliver'">
                          发货时间：{{ o.sendTime }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div style="width:30%" class="table-bodys not-bder flex ">
                  <div class="flex-1 flex" style="flex-flow: column nowrap;justify-content: center;align-items: center;">
                    <div class="text-left" v-if="v.payState === 'yes'">
                      <div class="">运费:￥{{ v.deliverMoney }}</div>
                      <div v-if="v.packageMoney">包装费:￥{{ v.packageMoney }}</div>
                      <div class="primary" v-if="v.isOverseas === 'yes'">
                        税费:￥{{ v.taxFee }}
                      </div>
                      <div
                        class="primary"
                        v-if="v.orderType === 'integral_order'"
                      >
                        应付:<span v-if="v.payPrice">￥{{ v.payPrice }}+</span>
                        {{ v.integralPoint }}积分
                      </div>
                      <div
                        class="primary"
                        v-if="v.orderType === 'integral_order'"
                      >
                        实付:<span v-if="v.actuallyPrice"
                          >￥{{ v.actuallyPrice }}+</span
                        >
                        {{ v.integralPoint }}积分
                      </div>
                      <div
                        class="primary"
                        v-if="v.orderType !== 'integral_order'"
                      >
                        应付:￥{{ v.payPrice }}
                      </div>
                      <div
                        class="primary"
                        v-if="v.orderType !== 'integral_order'"
                      >
                        实付:￥{{ v.actuallyPrice }}
                      </div>

                      <!-- <div>
                        下单会员：{{ v.memberName }}/{{ v.memberMobile }}
                      </div> -->
                      <div>
                        <span
                          v-if="v.payMode === 'wx_pay'"
                          class="hmicon icon-weixin1 success"
                          style="fontSize:23px"
                        ></span>
                        <span
                          v-if="v.payMode === 'ali_pay'"
                          class="hmicon icon-zhifubao blue"
                          style="fontSize:23px"
                        ></span>
                        <span v-if="v.payMode === '0_pay'">0元订单</span>
                      </div>
                    </div>
                    <div v-else>
                      未支付
                    </div>
                    <el-button v-if="searchCondition.orderState == 'createOrder' && !isBtn('cancelOrder:true')" style="margin-top: 10px" type="primary" size="small" @click="cancelOrder(v)">取消订单</el-button>
                    <!-- <el-button v-if="searchCondition.orderState == 'createOrder' && !isBtn('cancelOrder:true')" :style="{width: '100px',height: '30px'}" type="danger" size="mini" @click="cancelOrder(v)" plain>取消订单</el-button> -->
                  </div>
                  <!-- <div class="flex-2 ">
                    <div>
                      张晓东 13121869388
                    </div>
                    <div>
                      请安排在五一左右发货
                    </div>
                  </div> -->
                  <div class="flex-2" style="textAlign:left">
                    <!-- <div>
                      会员名称/手机号：{{ v.memberName }} /{{ v.memberMobile }}
                    </div> -->
                    <div>
                      收件人：{{ v.receiverName }} / {{ v.receiverMobile }}
                    </div>

                    <div>
                      收件地址：{{ v.deliveryProvince }}{{ v.deliveryAddress }}
                    </div>
                    <div style="fontWeight:600">备注：{{ v.orderRemark }}</div>
                    <div class="">
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        v-if="v.deliveryType === 'mdzt'"
                        >门店自提</el-tag
                      >
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        v-if="v.deliveryType === 'kdfh'"
                        >快递发货</el-tag
                      >
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        v-if="v.deliveryType === 'tcps'"
                        >同城配送</el-tag
                      >
                    </div>
                    <div>
                      <el-button
                        size="small"
                        class="blue"
                        type="text"
                        @click="toDetails(v)"
                        >订单详情</el-button
                      >
                      <el-button
                        size="small"
                        type="text"
                        class="blue"
                        @click="editDeliveryInfo(v, 'table')"
                        >修改收货信息</el-button
                      >
                      <el-button
                        size="small"
                        type="text"
                        class="blue"
                        v-if="v.deliveryType === 'kdfh'"
                        :class="
                          v.orderState === 'createOrder' ||
                          v.orderState === 'payOrder'
                            ? 'gray'
                            : ''
                        "
                        :disabled="
                          v.orderState === 'createOrder' ||
                            v.orderState === 'payOrder'
                        "
                        @click="orderDetail(v)"
                        >快递发货</el-button
                      >
                      <el-button
                        size="small"
                        type="text"
                        class="blue"
                        @click="offlineOrderRefund(v)"
                        v-if="v.isShowOfflineOrderRefund"
                        >更改线下已退款订单状态</el-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="order-bder flex flex-center empty"
              v-if="list.length === 0"
            >
              <div class="empty">
                <img class="img_no" src="../../assets/n001.jpg" alt="" />
                <p class="empty_tex">请设置查询条件后查询</p>
              </div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1200px"
    >
      <div slot="title">
        <span class="mr10">订单详情</span>
        <span class="form-item-tip" style="color: #fF0000"
          >当前订单状态：{{ orderSta }}</span
        >
      </div>
      <div class="content">
        <div class="progress">
          <el-steps :active="active" align-center>
            <el-step title="创建订单" :description="createOrderTime"></el-step>
            <el-step title="支付订单" :description="payOrderTime"></el-step>
            <el-step
              title="平台配货发货"
              :description="deliverOrderTime"
            ></el-step>
            <el-step title="确认收货" :description="takeOrderTime"></el-step>
            <el-step title="完成评价" :description="pushOrderTime"></el-step>
          </el-steps>
        </div>
        <ul class="info-list mt10">
          <li>
            <div class="mb10">
              <el-button
                type="primary"
                size="small"
                :disabled="disabled"
                @click="openSendDialog"
                >去发货</el-button
              >
              <el-button
                type="primary"
                size="small"
                :disabled="delivery"
                @click="sureArrive"
                >确认送达</el-button
              >
              <el-button
                type="primary"
                size="small"
                :disabled="disabled"
                @click="openSendDialog2(orderDetails.receiptSn,orderGoods[0].supplierId,orderDetails.purchaseTime)"
                v-if="orderDetails.orderState === 'payOrder' && !isBtn('bendanqufahuo:true')"
                >本单去发货</el-button
              >
            </div>
            <div class="flex flex-between mb10">
              <div class="flex flex-wrap">
                <div class="title mr10">基本信息</div>
                <!-- <el-tag
                  size="mini"
                  effect="plain"
                  color="#FFEEF6"
                  v-if="orderDetails.isOverseas === 'yes'"
                  >海外购</el-tag
                > -->
              </div>
              <div
                v-if="
                  active === 1 ||
                    active === 2 ||
                    (active === 3 && orderDetails.orderSpuType === 'virtual')
                "
              >
                <el-select
                  clearable
                  v-model="belongShopId"
                  placeholder="请选择门店"
                  size="small"
                  filterable
                  class="mr10"
                >
                  <el-option
                    :label="v.shopName"
                    :value="v.shopId"
                    v-for="(v, i) in shopListJoinType.filter(item => item.isAccept !== 'no')"
                    :key="i"
                  ></el-option>
                </el-select>
                <el-button
                  :disabled="!belongShopId"
                  type="primary"
                  size="small"
                  @click="designate"
                  >重新指派</el-button
                >
              </div>
            </div>

            <div class="mb20">
              <el-table stripe border :data="[orderDetails]" size="small">
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiptSn"
                  label="订单信息"
                >
                  <template slot-scope="scope">
                    <div class="text-left">
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        v-if="scope.row.orderType === 'integral_order'"
                        >积分兑换订单</el-tag
                      >
                      <div>订单号：{{ scope.row.receiptSn }}</div>
                      <div>
                        是否拆单发货：{{
                          scope.row.packageNum > 1 ? "是" : "否"
                        }}
                      </div>
                      <div v-if="scope.row.outTradeNo">
                        海关单号：{{ scope.row.outTradeNo }}
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="shareMemberName"
                  label="推荐关系"
                >
                  <template slot-scope="scope">
                    <div class="text-left">
                      <div>
                        推荐类型：{{
                          scope.row.shareMemberName !== null &&
                          scope.row.platformId !== "smg"
                            ? "分销"
                            : ""
                        }}
                      </div>
                      <div>
                        分销会员：{{ scope.row.shareMemberName }}/{{
                          scope.row.shareMemberMobile
                        }}
                      </div>
                      <div>所属机构：{{ scope.row.departName }}</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiptSn"
                  label="订单主体"
                >
                  <template slot-scope="scope">
                    <div class="text-left">
                      <div>下单会员：{{ scope.row.memberName }}</div>
                      <div>
                        收货人：{{ scope.row.receiverName }}/{{
                          scope.row.receiverMobile
                        }}
                      </div>
                      <div>
                        收货地址：{{ scope.row.deliveryProvince
                        }}{{ scope.row.deliveryAddress }}
                      </div>
                      <el-button
                        size="small"
                        type="text"
                        class="blue"
                        @click="editDeliveryInfo(scope.row, 'detail')"
                        >修改收货信息</el-button
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="receiptSn"
                  label="费用信息"
                >
                  <template slot-scope="scope">
                    <div class="text-left">
                      <div>
                        商品合计金额：+￥{{
                          scope.row.markupMoney
                            ? scope.row.totalPrice + scope.row.markupMoney
                            : scope.row.totalPrice
                        }}
                      </div>
                      <div v-if="scope.row.orderType === 'integral_order'">
                        积 分：+{{ scope.row.integralPoint }}
                      </div>
                      <div>优 惠 券：-￥{{ scope.row.couponMoney }}</div>
                      <div>优惠券信息：{{ scope.row.couponName }}</div>
                      <div>活 动：-￥{{ scope.row.activeMoney }}</div>
                      <div v-if="scope.row.isOverseas === 'yes'">
                        税 费：+￥{{ scope.row.taxFee }}
                      </div>
                      <div>运 费：+￥{{ scope.row.deliverMoney }}</div>
                      <div v-if="scope.row.packageMoney">
                        包装费：+￥{{ scope.row.packageMoney }}
                      </div>
                      <div v-if="scope.row.deliverCouponMoney">
                        运费券：-{{ scope.row.deliverCouponMoney }}
                      </div>
                      <div
                        v-if="
                          scope.row.otherPayInfo &&
                            scope.row.otherPayInfo.length
                        "
                      >
                        <div v-for="(v, i) in scope.row.otherPayInfo" :key="i">
                          <div v-if="v.financeCode === 'goldBean'">
                            金豆：已用{{ v.financeValue
                            }}{{ v.relName }}抵用-￥{{ v.currencyAmount }}
                          </div>
                        </div>
                      </div>
                      <div class="flex flex-between">
                        <div>储 值 卡：-￥{{ scope.row.prepayMoney }}</div>
                        <div
                          style="fontWeight:600"
                          v-if="orderDetails.payMode !== 'no_pay'"
                        >
                          <div v-if="scope.row.orderType === 'integral_order'">
                            实付款:<span v-if="scope.row.actuallyPrice"
                              >￥{{ scope.row.actuallyPrice }}+</span
                            >
                            {{ scope.row.integralPoint }}积分
                          </div>
                          <div v-else>
                            实付款：{{ scope.row.actuallyPrice }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </li>
          <li class="mb20">
            <div class="flex flex-between">
              <div class="title">
                商品信息
                <span class="form-red">
                  相同的商品不支持拆分退款，选中退款的商品，如果订单中有相同商品将一并退款。
                </span>
              </div>
              <div
                class="flex flex-end item-center"
                v-if="
                  orderDetails.payMode !== 'no_pay' && isBtn('tuikuan:false')
                "
              >
                <span class="pointer mr10" @click="batchReturn">
                  <span class="hmicon icon-tuikuan"> </span>
                  批量退款
                </span>
              </div>
            </div>

            <el-table
              border
              :data="orderGoods"
              :span-method="objectSpanMethod"
              @selection-change="getCheckedReturn"
              size="small"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                type="selection"
                width="50"
                header-align="center"
                align="center"
                :selectable="checkSelectable"
                v-show="
                  orderDetails.payMode !== 'no_pay' && isBtn('tuikuan:false')
                "
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsImg"
                label="商品图片"
                width="160px"
              >
                <template slot-scope="scope">
                  <div>
                    <div
                      class="flex flex-center item-center"
                      v-if="scope.row.returnType !== 'no'"
                    >
                      <!-- 换货中 -->
                      <img
                              class="table-only-tuikuan p10"
                              v-if="scope.row.changeStatus == 'auditWait' || scope.row.changeStatus == 'changeWait' || scope.row.changeStatus == 'changeDo'"
                              style="width:100px;height:100px"
                              src="https://imgcdn.hemiao100.com/hemiaoBase/%E6%8D%A2%E8%B4%A7%402x.png"
                              alt=""
                      />
                      <!-- 仅退款 -->
                      <img
                        v-if="scope.row.refundReturnType === 'money'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/81d2994f64c85809bf951f14fd56ecc.png"
                        alt=""
                      />

                      <!-- 退货退款 -->
                      <img
                        v-if="scope.row.refundReturnType === 'refund'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/8088827e177ba800a9eba2c17e295c8.png"
                        alt=""
                      />

                      <!-- 退运费 -->
                      <img
                        v-if="scope.row.refundReturnType === 'deliver'"
                        style="width:100px;height:100px"
                        src="https://imgcdn.hemiao100.com/hemiaoBase/9a0ad12b4cead9d04371c126a61d5d5.png"
                        alt=""
                      />
                    </div>

                    <img
                      class="warning-tuikuan"
                      v-show="scope.row.returnType === 'yes'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E5%B7%B2%E9%80%80%E6%AC%BE.png"
                      alt=""
                    />
                    <img
                      class="warning-tuikuan"
                      v-show="scope.row.returnType === 'doing'"
                      src="https://imgcdn.hemiao100.com/hemiaoBase/%E9%80%80%E6%AC%BE%E4%B8%AD.png"
                      alt=""
                    />
                    <div
                      class="flex flex-center item-center"
                      :class="
                        scope.row.returnType !== 'no' ? 'only-tuikuan' : ''
                      "
                    >
                      <div>
                        <img
                          style="width:100px;height:100px;"
                          v-if="scope.row.goodsImg"
                          :src="scope.row.goodsImg"
                          alt=""
                        />
                        <div style="width:100%">
                          <el-tag
                            style="width:100%"
                            size="mini"
                            effect="plain"
                            type="success"
                            v-if="scope.row.isGift === 'gift'"
                            >赠 品</el-tag
                          >
                          <el-tag
                            style="width:100%"
                            size="mini"
                            effect="dark"
                            type="success"
                            v-else-if="scope.row.isGift === 'markup'"
                            >加价购商品</el-tag
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="商品名称/品牌"
                width="200"
              >
                <template slot-scope="scope">
                  <p>
                    <el-tag
                  size="mini"
                  effect="plain"
                  color="#FFEEF6"
                  v-if="scope.row.isOverseas === 'yes'"
                  >海外购</el-tag
                  >
                {{ scope.row.spuName }}</p>
                  <p>品牌: {{ scope.row.brandName }}</p>
                  <el-tag type="warning"
                    >{{
                      scope.row.spuType === "virtual" ? "虚拟" : "实物"
                    }}商品</el-tag
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="价格/货号"
              >
                <template slot-scope="scope">
                  <p>价格: ￥{{ scope.row.totalPrice }}</p>
                  <p>货号: {{ scope.row.goodsSn }}</p>
                  <p>条码: {{ scope.row.barCode }}</p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="净重/毛重"
              >
                <template slot-scope="scope">
                  <p v-if="scope.row.netWeight">
                    净重: {{ scope.row.netWeight }}
                  </p>
                  <p v-if="scope.row.grossWeight">
                    毛重: {{ scope.row.grossWeight }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                label="规格"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="数量"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="totalPrice"
                label="小计金额"
              >
                <template slot-scope="scope">
                  <p>
                    ￥{{ ToFixed(scope.row.payPrice * scope.row.goodsNum, 2) }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div
                    v-if="
                      orderDetails.payMode !== 'no_pay' &&
                        isBtn('tuikuan:false')
                    "
                  >
                    <!-- v-if="
                        (scope.row.spuType === 'virtual' &&
                          scope.row.memberLaunchRefund === 'yes') ||
                          scope.row.spuType !== 'virtual'
                      " -->
                    <el-button
                      :disabled="scope.row.returnType !== 'no' || orderSta === '待付款' || orderSta === '已取消'"
                      size="small"
                      class="danger"
                      type="text"
                      @click="refund(scope.row)"
                      >退款</el-button><br />
                    <el-button
                            size="small"
                            class="danger"
                            type="text"
                            :disabled="orderSta === '待付款' || orderSta === '已取消'"
                            v-if="((scope.row.changeStatus == 'allowChange' || scope.row.changeStatus == 'changeDo' || scope.row.changeStatus == 'refuse') && scope.row.returnType === 'no') && !isBtn('huanhuo:true')"
                            @click="exchangeGoodes(scope.row)"
                      >换货</el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                label="留言信息"
                header-align="center"
                align="center"
                prop="messageJson"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.messageJson">
                  <div v-for="(v, i) in JSON.parse(scope.row.messageJson)" :key="i">
                      <span v-if="v.messageType==='text' && v.messageContent != ''"><span>{{v.messageName}}:</span>{{v.messageContent}}</span>
                      <span v-if="v.messageType==='img' && v.messageContent != ''"><span>{{v.messageName}}:</span>
                        <el-image
                          style="width:50px; height:50px"
                          :src="v.messageContent"
                          :preview-src-list="[v.messageContent]"
                        >
                        </el-image>
                      </span>
                  </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                prop="expressQueryId"
                label="包裹信息"
                width="180"
              >
                <template slot-scope="scope">
                  <div>
                    <div>
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        v-if="scope.row.expressState === 'waitAllocation'"
                        >待配货</el-tag
                      >
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        v-if="scope.row.expressState === 'waitDeliver'"
                        >待发货</el-tag
                      >
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        v-if="scope.row.expressState === 'alreadyDeliver'"
                        >已发货</el-tag
                      >
                      <el-tag
                        size="mini"
                        effect="plain"
                        color="#FFEEF6"
                        v-if="!!scope.row.supplierId"
                        >三方</el-tag
                      >
                      <el-tag size="mini" effect="plain" color="#FFEEF6" v-else
                        >自营</el-tag
                      >
                    </div>
                    <div>发货单号:{{ scope.row.deliverSn }}</div>
                    <div>快递单号:{{ scope.row.expressOrderSn }}</div>
                    <div
                      class="mb10"
                      v-if="scope.row.expressState === 'alreadyDeliver'"
                    >
                      发货门店：{{ scope.row.sendShopName }}
                    </div>
                    <div v-if="scope.row.expressState === 'alreadyDeliver'">
                      发货时间：{{ scope.row.sendTime }}
                    </div>
                  </div>
                </template>
              </el-table-column>

            </el-table>
          </li>
          <li class="mb20">
            <div class="title">操作信息</div>
            <el-table stripe border :data="orderStatus" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="operatorAccount"
                label="操作账号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operatorName"
                label="操作人"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.operatorName === null">
                    {{ scope.row.createBy }}
                  </div>
                  <div v-else>
                    {{ scope.row.operatorName }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="createTime"
                label="操作时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="订单状态"
              >
                <template slot-scope="scope">
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'createOrder'"
                    >待付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'payOrder'"
                    >待发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'deliverOrder'"
                    >已发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'takeOrder'"
                    >已收货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'pushOrder'"
                    >已评价</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'delOrder'"
                    >已取消</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'returnOrder'"
                    >有退货退款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'over3month_order_oa_approval'"
                    >更改线下已退款订单状态</span
                  >
                  <span
                          class="status"
                          style="color: red"
                          v-if="scope.row.orderStatus === 'changeDo' || scope.row.orderStatus === 'refuse'"
                  >有换货</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="付款状态"
              >
                <template slot-scope="scope">
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'createOrder'"
                    >未付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'payOrder'"
                    >已付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'deliverOrder'"
                    >已付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'takeOrder'"
                    >已付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'pushOrder'"
                    >已付款</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'delOrder'"
                    >已取消</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="spuName"
                label="发货状态"
              >
                <template slot-scope="scope">
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'createOrder'"
                    >未发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'payOrder'"
                    >未发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'deliverOrder'"
                    >已发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'takeOrder'"
                    >已发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'pushOrder'"
                    >已发货</span
                  >
                  <span
                    class="status blue"
                    v-if="scope.row.orderStatus === 'delOrder'"
                    >已取消</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="remark"
                label="备注"
              ></el-table-column>
              <!-- <el-table-column
                header-align="center"
                align="center"
                label="操作"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button size="small" type="text" @click="beizhu(scope.row)"
                      >添加备注</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
            </el-table>
          </li>
          <li class="mb20">
            <div class="title">门店变更记录</div>
            <el-table
              stripe
              border
              :data="shopOperateLogModelList"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="createBy"
                label="操作账号"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作人"
              >
                <template slot-scope="scope">
                  <div v-if="scope.row.operatorName === null">
                    {{ scope.row.createBy }}
                  </div>
                  <div v-else>
                    {{ scope.row.createBy }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="operateTime"
                label="操作时间"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="beforeShopName"
                label="变更前门店"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="afterShopName"
                label="变更后门店"
              >
              </el-table-column>
            </el-table>
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="close" size="small" type="primary">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="exchangeGoodWindow">
      <div slot="title" style="line-height: 40px;font-size: 20px;"><span>您要申请“{{exchangeForm.changeGoodsName}}”换货吗？</span>
        <div style="color: #ff0000; line-height: 20px; font-size: 12px;">（只能兑换等量数量的商品）</div></div>
      <el-form :model="exchangeForm" >
        <div style="line-height: 40px">
          选择商品：<el-input
                v-model="exchangeGoodName"
                placeholder="请选择商品"
                @focus="inputChange"
                style="width: 60%"
                size="samll"
                suffix-icon="el-icon-arrow-right">
        </el-input>
          <br/>
          换货数量：<el-input v-model="exchangeForm.changeGoodsNum" disabled style="width: 60%; margin-top: 5px" size="samll"></el-input>
          <br/>
          换货原因：<el-input
                  style="width: 60%; margin-top: 5px"
                  type="textarea"
                  :rows="2"
                  placeholder="请输入换货理由"
                  v-model="exchangeForm.changeReason">
          </el-input>
        </div>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="closeChangeGood()">提交申请</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="退款"
      :close-on-click-modal="false"
      :visible.sync="dialogRetrun"
      :before-close="returnClose"
      width="1000px"
    >
      <div slot="title">
        <span
          class="mr10"
          style="color: #222;font-size: 16px;font-weight: bold;"
          >退款</span
        >
        <span class="hmicon icon-tishi orange"></span>
        <span class="orange"
          >受支付平台限制超过三个月的订单需要人工退款，系统不支持自动退款</span
        >
      </div>
      <el-dialog
        :close-on-click-modal="false"
        width="600px"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div slot="title">
          <div class="danger" style="font-size:16px;font-weight: bold;">
            请确认是否退款！
          </div>
        </div>
        <div>
          <div v-for="(v, i) in couponUsedList" :key="i">
            该订单赠送的 <span class="primary">【 {{ v.name }}】</span> ,已在
            <span class="primary">{{ v.toOrder }}</span> 订单使用！
          </div>
        </div>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button @click="againSubmitReturn" size="small" type="primary"
            >继续退款</el-button
          >
          <el-button @click="innerVisible = false" size="small"
            >取 消</el-button
          >
        </span>
      </el-dialog>
      <el-image
        class="mb10"
        src="https://imgcdn.hemiao100.com/ThemePictures/tuikuantip.png"
      ></el-image>
      <el-form
        :model="ruleFormRetrun"
        :rules="rulesRetrunrules"
        ref="ruleFormRetrun"
        label-width="80px"
      >
        <el-form-item label="退款方式" prop="returnType">
          <el-select
            size="small"
            filterable
            class="mr10"
            clearable
            v-model="ruleFormRetrun.returnType"
            placeholder="请选择退款方式"
          >
            <el-option label="仅退款" value="money"> </el-option>
            <el-option
              label="超时未取货退款"
              value="overTimeNoPickUp"
              v-if="orderDetails.deliveryType === 'mdzt'"
            >
            </el-option>
            <el-option
              label="退货退款"
              value="refund"
              v-if="orderDetails.isSend === 'yes'"
            >
            </el-option>
            <el-option
              label="退运费"
              value="deliver"
              v-if="orderDetails.deliveryType !== 'mdzt'"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="退运费"
          prop="returnDeliverMoney"
          v-if="orderDetails.deliveryType !== 'mdzt'"
        >
          <div>最多可退{{ useReturnDeliverMoney }}元</div>
          <el-input
            clearable
            v-model.trim="ruleFormRetrun.returnDeliverMoney"
            @input="filterGt0OrFixed2('returnDeliverMoney')"
            placeholder="请输入退运费金额"
            size="small"
            class="mr10"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="退包装费"
          prop="returnPackageMoney"
          v-if="orderDetails.deliveryType === 'tcps'"
        >
          <div>最多可退{{ useReturnPackageMoney }}元</div>
          <el-input
            clearable
            v-model.trim="ruleFormRetrun.returnPackageMoney"
            @input="filterGt0OrFixed2('returnPackageMoney')"
            placeholder="请输入退运费金额"
            size="small"
            class="mr10"
          ></el-input>
        </el-form-item>
        <el-form-item
          v-if="ruleFormRetrun.returnType === 'deliver'"
          label="退款备注"
          prop="returnContext"
          :rules="{
            required: true,
            message: '请输入退款备注',
            trigger: 'blur'
          }"
        >
          <el-input
            clearable
            maxlength="150"
            :autosize="{ minRows: 5, maxRows: 17 }"
            type="textarea"
            v-model.trim="ruleFormRetrun.returnContext"
            placeholder="请输入退款备注"
            size="small"
            class="mr10"
          ></el-input>
        </el-form-item>
        <el-form-item label="退款备注" prop="returnContext" v-else>
          <el-input
            clearable
            maxlength="150"
            :autosize="{ minRows: 5, maxRows: 17 }"
            type="textarea"
            v-model.trim="ruleFormRetrun.returnContext"
            placeholder="请输入退款备注"
            size="small"
            class="mr10"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button @click="submitReturn" size="small" type="primary"
          >确 认</el-button
        >
        <el-button @click="returnClose" size="small">取 消</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改收货信息"
      :close-on-click-modal="false"
      :visible.sync="dialogResetForm"
    >
      <el-form
        :model="ruleFormReset"
        :rules="rulesResetrules"
        ref="ruleFormReset"
        label-width="150px"
        class="demo-ruleForm"
      >
        <!-- <el-form-item
          label="订单备注"
          prop="orderRemark"
          v-if="editType === 'remark'"
        >
          <el-input
            size="small"
            type="textarea"
            clearable
            placeholder="请输入订单备注"
            v-model="ruleFormReset.orderRemark"
          ></el-input>
        </el-form-item> -->
        <div>
          <el-form-item label="收货人" prop="receiverName">
            <el-input
              size="small"
              clearable
              placeholder="请输入收货人"
              v-model="ruleFormReset.receiverName"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="receiverMobile">
            <el-input
              size="small"
              clearable
              placeholder="请输入手机号码"
              v-model="ruleFormReset.receiverMobile"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="邮政编码" prop="receiverMobile">
            <el-input
              size="small"
              clearable
              placeholder="请输入邮政编码"
              v-model="ruleFormReset.receiverMobile"
            ></el-input>
          </el-form-item> -->
          <el-form-item label="收货人详细地址" prop="deliveryAddress">
            <el-input
              size="small"
              type="textarea"
              clearable
              placeholder="请输入详细地址"
              v-model="ruleFormReset.deliveryAddress"
            ></el-input>
          </el-form-item>
        </div>

        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitForm"
            >提交</el-button
          >
          <el-button size="small" @click="dialogResetForm = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="logisticsInfoVisible"
    >
      <div slot="title">
        <span class="mr10">物流快递</span>
      </div>
      <ul class="logistics-list">
        <li class="flex mb10">
          <div class="flex-1">
            <div class="title">发件人信息</div>
            <div class="content-item">
              <span>操作人名称：</span>
              <span class="info">{{ showLogsistics.order.createBy }}</span>
            </div>
            <!-- <div class="content-item">
              <span>发件人地址：</span>
              <span class="info"
                >武汉市东西湖技术开发区光谷步行街A地 块B区4楼403室</span
              >
            </div> -->
            <div class="content-item">
              <span>操作人电话：</span>
              <span class="info">{{ showLogsistics.order.phone }}</span>
            </div>
          </div>
          <div class="flex-1">
            <div class="title">收件人信息</div>
            <div class="content-item">
              <span>收件人名称：</span>
              <span class="info">{{ showLogsistics.order.receiverName }}</span>
            </div>
            <div class="content-item">
              <span>发收件人地址：</span>
              <span class="info">{{
                showLogsistics.order.deliveryAddress
              }}</span>
            </div>
            <div class="content-item">
              <span>收件人电话：</span>
              <span class="info">{{
                showLogsistics.order.receiverMobile
              }}</span>
            </div>
          </div>
        </li>
        <li class="mb10">
          <div class="title">订单明细</div>
          <div class="mb20">
            <el-table stripe border :data="[showLogsistics.order]" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="订单号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="memberMobile"
                label="会员手机号"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="payMode"
                label="支付方式"
              >
                <template slot-scope="scope">
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'no_pay'"
                    >未支付</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === '0_pay'"
                    >0元订单</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'wx_pay'"
                    >微信支付</span
                  >
                  <span
                    class="status danger"
                    v-if="scope.row.payMode === 'ali_pay'"
                    >支付支付</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderSource"
                label="订单来源"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="orderType"
                label="订单类型"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.orderType === 'wshop'">微店订单</span>
                  <span v-if="scope.row.orderType === 'ptdd'">拼团订单</span>
                  <span v-if="scope.row.orderType === 'kjdd'">砍价订单</span>
                  <span v-if="scope.row.orderType === 'mshd'">秒杀订单</span>
                  <span v-if="scope.row.orderType === 'smg_faceToFace'"
                    >代客下单-当面收款</span
                  >
                  <span v-if="scope.row.orderType === 'smg_netPush'"
                    >代客下单-网络推送</span
                  >
                  <span v-if="scope.row.orderType === 'dhdd'">兑换订单</span>
                  <span v-if="scope.row.orderType === 'integral_order'"
                    >积分兑换订单</span
                  >
                  <span v-if="scope.row.orderType === 'combination_set_order'"
                    >组合套餐订单</span
                  >
                  <span v-if="scope.row.orderType === 'jielong_order'"
                    >接龙订单</span
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="form-item-tip">
            备注：{{ showLogsistics.order.orderRemark }}
          </div>
        </li>
        <li>
          <div class="title">物流信息</div>
          <div>
            <!-- <el-steps direction="vertical" :active="1">
              <el-step title="已签收" icon="el-icon-edit"></el-step>
               <el-step
                :title="v.AcceptTime"
                :description="v.AcceptStation"
                v-for="(v, i) in showLogsistics.courierInfo.traces"
                :key="i"
              ></el-step>
              <el-step title="已揽件" description="包裹正在等待揽收"></el-step>
              <el-step title="已下单" ></el-step>

            </el-steps> -->

            <div class="div-bg bg-white" style="background:#f7f7f7">
              <div
                style="height: 0.5rem;width: 100%;backgroundColor:#f7f7f7"
              ></div>
              <!--物流跟踪-->
              <div style="paddingBottom: 0.5rem;">
                <div
                  class="bg-white"
                  style="width: 92%; marginLeft: 4%;margin: auto;paddingLeft: 15px;paddingRight: 15px;"
                >
                  <div>
                    <div class="track-rcol">
                      <div class="track-list">
                        <el-scrollbar
                          :vertical="false"
                          wrap-style="max-height: 400px;"
                        >
                          <ul>
                            <div
                              v-for="(item, index) in showLogsistics.courierInfo
                                .traces"
                              :key="index"
                            >
                              <li :class="index === 0 ? 'first' : ''">
                                <div></div>
                                <i class="node-icon"></i>
                                <span class="txt">{{
                                  item.AcceptStation
                                }}</span>
                                <span class="time">{{ item.AcceptTime }}</span>
                              </li>
                            </div>
                          </ul>
                        </el-scrollbar>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer flex flex-center">
        <el-button
          @click="logisticsInfoVisible = false"
          size="small"
          type="primary"
          >关闭</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="请选择商品"
      width="80%"
      :visible.sync="selectAllGoods"
    ><div class="p20">
      <div class="table-panel flex flex-between">
        <div class="flex-1 text-right">
          <!-- <el-cascader
            v-model="searchCondition.wxshopCategoryId"
            :show-all-levels="false"
            size="small"
            class="mr10"
            :props="categoryFunc"
            clearable
            placeholder="请选择类目"
          ></el-cascader> -->
          <el-input
                  clearable
                  style="width: 200px"
                  v-model.trim="newSearchCondition.keyWords"
                  placeholder="请输入货号/条码/商品名/品牌"
                  size="small"
                  class="ipt mr10"
          ></el-input>
          <el-select
                  size="small"
                  class="mr10"
                  v-model="newSearchCondition.salesState"
                  clearable
                  placeholder="请选择上架状态">
              <el-option
                v-for="(v,i) in salesState"
                :key="i"
                :label="v.value"
                :value="v.key"
              ></el-option>
          </el-select>
          <el-cascader
                  v-model="newSearchCondition.wxshopCategoryId"
                  :show-all-levels="false"
                  size="small"
                  class="mr10"
                  :props="categoryFunc"
                  clearable
                  placeholder="请选择微店商品分类"
          ></el-cascader>
          <el-cascader
                  v-model="newSearchCondition.attributeId"
                  placeholder="请选择辅助属性"
                  :show-all-levels="false"
                  size="small"
                  class="mr10"
                  :props="attributeFunc"
                  clearable
          ></el-cascader>

          <el-button type="primary" size="small" @click="searchShop"
          >查询</el-button
          >
        </div>
      </div>
      <el-table
              :data="listShop"
              stripe
              border
              ref="brandTable"
              :highlight-current-row="radio"
              @current-change="handleCurrentChange"
              @selection-change="handleSelectionChange"
              style="width: 100%"
              id="table"
              size="small"
              @select="select"
              @select-all="selectAll"
      >
        <el-table-column type="selection"></el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="wxshopSpuName"
                label="商品名称"
        >
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="specBarCode"
                label="商品货号"
        >
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="stockNum"
                label="商品库存"
        >
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="specIdGroupName"
                label="商品规格"
        >
        </el-table-column>
        <el-table-column
                header-align="center"
                align="center"
                prop="wxshopPrice"
                label="价格信息"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
                background
                :total="total"
                @current-change="pagings"
                @size-change="handleSizeChanges"
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage"
        ></el-pagination>
      </div>
      <div class="btn-wrapper mb20 flex flex-center" style="margin-top: 20px">
        <el-button size="small" type="primary" @click="closeSelectGoods"
        >确 定</el-button
        >
        <el-button size="small" @click="selectAllGoods = false">取 消</el-button>
      </div>
    </div>
    </el-dialog>
    <el-dialog
      title="更改线下已退款订单状态"
      :close-on-click-modal="false"
      :visible.sync="dialogOfflineOrderRefund"
    >
      <div class="mb10" v-if="!operateTimeOfflineOrderRefund">您要申请更改“订单号：{{receiptSnRow}}”的状态？</div>
      <div class="mb10 danger" v-if="!operateTimeOfflineOrderRefund">注意 当前的操作针对的是线上超过3个月的订单，线下已经申请退款需要修改线上订单状态(不涉及积分和优惠券退还)，请审核无误后上传线下已经退款的凭据，请勿随意操作！！</div>
      <el-form
        :model="ruleFormOfflineOrderRefund"
        :rules="rulesOfflineOrderRefundrules"
        ref="ruleFormOfflineOrderRefund"
        label-width="150px"
        class="demo-ruleForm"
      >
        <div>
          <el-form-item label="退款凭证:" prop="pic">
            <el-upload
              class="upload flex"
              ref="eluploadMainPic"
              :limit="1"
              drag
              :data="{ fileDir: 'mall' }"
              :headers="{ 'X-Access-Token': $token }"
              :action="$uploadUrl"
              :onSuccess="uploadMainPicSucc"
              :beforeUpload="beforeUpload"
              :onProgress="uploading"
              :show-file-list="uploadShow"
              v-if="!ruleFormOfflineOrderRefund.pic"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                将图片拖到此处，或
                <em>点击上传</em>
              </div>
            </el-upload>
            <div class="priview" v-if="ruleFormOfflineOrderRefund.pic">
              <el-image
                class="image"
                :src="ruleFormOfflineOrderRefund.pic"
                alt="主图"
                :preview-src-list="[ruleFormOfflineOrderRefund.pic]"
                />
              <div class="opreat-wrapper flex item-center flex-center" v-if="!operateTimeOfflineOrderRefund">
                <el-button type="text" @click="handleRemove">删除</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item class="mb10" label="备注:" prop="remark">
            <el-input
              style="height:100%"
              class="remark-tarea"
              size="small"
              type="textarea"
              clearable
              placeholder="请输入商品备注"
              maxlength="128"
              v-model="ruleFormOfflineOrderRefund.remark"
              :disabled="disabledRemark"
            ></el-input>
          </el-form-item>
          <el-form-item class="mb10" label="操作时间:" prop="operateTime" v-if="operateTimeOfflineOrderRefund">
            <div>{{operateTimeOfflineOrderRefund}}</div>
          </el-form-item>
          <el-form-item class="mb10" label="操作人:" prop="operateName" v-if="operateNameOfflineOrderRefund">
            <div>{{operateNameOfflineOrderRefund}}</div>
          </el-form-item>
        </div>
        <div class="flex flex-center">
          <el-button type="primary" size="small" @click="submitFormOfflineOrderRefund('ruleFormOfflineOrderRefund')" v-if="!operateTimeOfflineOrderRefund"
            >提交</el-button
          >
          <el-button size="small" @click="dialogOfflineOrderRefund = false"
            >取消</el-button
          >
        </div>
      </el-form>
    </el-dialog>
  </hm-content>
</template>

<script>
import { mapGetters } from "vuex";
// import { outPutMixin } from "@/mixins/outputMixin";
import { setCookie, getCookie, arrayUnique2, ToFixed, setLoginUser } from "@/utils/utils";
import moment from "moment";
import {getLoginUser} from "@/utils/auth";
import { timestampToDate } from "@/utils/utils";
export default {
  components: {},
  props:{
    radio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const validatorFunc = (rule, val, callback) => {
      if (val > this.useReturnDeliverMoney) {
        return callback(new Error(`运费最多可退${this.useReturnDeliverMoney}`));
      }
      callback();
    };
    const validatorFunc2 = (rule, val, callback) => {
      if (val > this.useReturnPackageMoney) {
        return callback(new Error(`包装费最多可退${this.useReturnPackageMoney}`));
      }
      callback();
    };
    const patternListHeader = function(rule, val, callback) {
      if (!this.ruleFormOfflineOrderRefund.pic) {
        return callback(new Error("请上传退款凭证"));
      }
      callback();
    }.bind(this);
    return {
      receiptSnHtml:"",
      isMessageJson:false,
      messageJsonList:[],
      checkBox:false,
      salesState:[
                  {
            key:'up',
            value:'已上架'
          },
        {
          key:'down',
          value:'未上架'
        }
      ],
      newSearchCondition: {
        salesState:'',
        keyWord:'',
        wxshopCategoryId:'',
        wxshopParentCategoryId:''
      },
      globalOrderStatus:{
        changeStatus: '',    //换货状态
        refundReturnType: ''   //订单状态
      },
      changeStatus: '',
      exchangeGoodName:'',
      exchangeGoodGG:'',
      selectGoodsTableData:{
        wxshopSkuId: '',
        wxshopSpuName: '',
        specBarCode: '',
        stockNum:'',
        specIdGroupName: '',
        wxshopPrice:''
      },
      checkedCurrentRow: {},
      checkedRow: [],
      selectAllGoods: false,
      wxshopSpuNames: [],
      exchangeForm: {
        receiptSn: '',  //购物小票  也就是订单编号
        wxshopSkuId:'',  // 原订单商品id
        goodsSn: '',  //原订单商品货号
        orderDetailId: '', //订单商品ID
        expressDetailId: '', //包裹明细ID
        changeWxshopSkuId: '', // 换货商品
        changeReason: '', //换货原因
        changeGoodsName: '', //原商品名称
        changeGoodsNum: ''
      },
      formLabelWidth: '120px',
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
                    .dispatch("queryMicroShopGoodsCategoryTree", {
                      categoryLevel: 1
                    })
                    .then(res => {
                      res.result.forEach(v => {
                        v.value = v.wxshopCategoryId;
                        v.label = v.categoryName;
                      });
                      resolve(res.result);
                    });
          } else {
            this.$store
                    .dispatch("queryMicroShopGoodsCategoryTree", {
                      categoryLevel: level + 1,
                      wxshopParentCategoryId: data.wxshopCategoryId
                    })
                    .then(res => {
                      this.level = level + 1;
                      if (res.code === "0" && res.result.length) {
                        res.result.forEach(v => {
                          v.value = v.wxshopCategoryId;
                          v.label = v.categoryName;
                        });
                        resolve(res.result);
                      } else {
                        resolve([]);
                      }
                    });
          }
        }
      },
      categoryFuncs: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.categoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryGoodsCategoryTree", {
                categoryLevel: level + 1,
                parentCategoryId: data.categoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.categoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      attributeFunc: {
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level } = node;
          if (level === 0) {
            this.$store.dispatch("queryAttrListByAddGoods").then(res => {
              res.result.forEach(v => {
                v.value = v.valueId;
                v.label = v.attributeValue;
              });
              resolve(res.result);
            });
          } else {
            let params = {};
            if (level === 1) {
              params = {
                typeId: node.data.valueId
              };
            } else {
              params = {
                attributeId: node.data.valueId
              };
            }
            this.$store
                    .dispatch("queryAttrListByAddGoods", params)
                    .then(res => {
                      this.level = level + 1;
                      if (res.code === "0" && res.result.length) {
                        res.result.forEach(v => {
                          v.value = v.valueId;
                          v.label = v.attributeValue;
                        });
                        resolve(res.result);
                      } else {
                        resolve([]);
                      }
                    });
          }
        }
      },
      ToFixed,
      exchangeGoodWindow: false,
      logisticsInfoVisible: false,
      showLogsistics: {
        order: {},
        courierInfo: {
          traces: []
        }
      },
      belongShopId: "",
      hidden: true,
      ruleFormReset: {
        orderId: "",
        receiverName: "",
        receiverMobile: "",
        deliveryAddress: ""
      },
      rulesResetrules: {
        receiverName: {
          required: true,
          message: "请输入收货人",
          trigger: "change"
        },
        receiverMobile: {
          required: true,
          pattern: /^1[0-9]{10}$/,
          message: "请输入正确的手机号",
          trigger: "blur"
        },
        deliveryAddress: {
          required: true,
          message: "请输入详细地址",
          trigger: "change"
        }
      },
      dialogResetForm: false,
      ruleFormRetrun: {
        returnType: "",
        returnDeliverMoney: "",
        returnPackageMoney: "",
        returnContext: ""
      },
      rulesRetrunrules: {
        returnType: {
          required: true,
          message: "请选择退款方式",
          trigger: "change"
        },
        returnDeliverMoney: [
          {
            required: true,
            message: "请输入退运费金额",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorFunc,
            trigger: "change"
          }
        ],
        returnPackageMoney: [
          {
            required: true,
            message: "请输入退包装费金额",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorFunc2,
            trigger: "change"
          }
        ],
        // returnContext: {
        //   required: this.ruleFormRetrun.returnType === "deliver",
        //   message: "请输入退款备注",
        //   trigger: "change"
        // }
      },
      dialogRetrun: false,
      dialogVisible: false,
      createOrderTime: "",
      payOrderTime: "",
      deliverOrderTime: "",
      takeOrderTime: "",
      pushOrderTime: "",
      active: 2,
      orderSta: "",
      placeholderSnType: "请输入订单号",
      placeholderGoodsType: "请输入商品名称",
      placeholderMemberType: "请输入会员名称",
      placeholderSourcType: "请输入会员名称",
      storeCode: "",
      dkShops: [],
      searchCondition: {
        orderState: "payOrder",
        querySnType: "receiptSn",
        queryGoodsType: "spuName",
        queryMemberType: "memberMobile",
        queryTimeType: "purchaseTime",
        timeStatus: "daifahuo",
        querySnValue: "",
        applyDate: [],
        gameId: "",
        mdztIsValid: false,
        expressState: "",
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      listShop:[],
      list: [
        // {
        //   expressModelList: [
        //     {
        //       goodsList: []
        //     }
        //   ]
        // }
      ],
      isOutputing: false,
      row: {},
      returnGoods: [],
      useReturnDeliverMoney: 0,
      useReturnPackageMoney: 0,
      payPrice: 0,
      actuallyPrice: 0,
      editType: "",
      supplierList: [],
      orNum: {},
      orderDetails: {},
      orderGoods: [],
      orderStatus: [],
      position: 0,
      rowSpanArr: [],
      goodsRow: {},
      typeDelivery: "",
      delivery: false,
      disabled: false,
      orderRefundInfoModelList: [],
      couponUsedList: [],
      innerVisible: false,
      shopOperateLogModelList: [],
      searchConditions: {
        settleState: '',
        dateValue: ""
      },
      dialogOfflineOrderRefund: false,
      ruleFormOfflineOrderRefund: {
        pic: "",
        remark: "",
      },
      rulesOfflineOrderRefundrules: {
        pic: [
          {
            required: true,
            validator: patternListHeader,
            trigger: "blur"
          }
        ],
      },
      uploadShow: true,
      receiptSnRow: "",
      operateTimeOfflineOrderRefund: "",
      operateNameOfflineOrderRefund: "",
      disabledRemark: false,
      shopListJoinType: []
    }
  },

  computed: mapGetters([
    "orderCenterList",
    "detailsOrder",
    "shopList",
    "orderAllCenterList",
    "vipCardTypeList",
    "dkMicroShopStoreList"
  ]),
  watch: {},
  created() {
    const startTime = moment()
      .subtract(3, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    const endTime = moment().format("YYYY-MM-DD HH:mm:ss");
    this.searchCondition.applyDate = [startTime, endTime];
    this.getParamsCookie();

    // console.log(this.$route.query);
    if (this.$route.query.time) {
      this.searchCondition.applyDate = JSON.parse(this.$route.query.time);
    }
    if (this.$route.query.type) {
      this.searchCondition.orderState = this.$route.query.type;
    }
    // 从接龙带过来的订单号
    if (this.$route.query.receiptSn) {
      // console.log("ooooo----oooo", this.$route.query.receiptSn);
      // this.searchCondition.receiptSn = this.$route.query.receiptSn;
      this.searchCondition.querySnValue = this.$route.query.receiptSn;
    }
    // 从接龙带过来的gameId
    if (this.$route.query.gameId) {
      this.searchCondition.gameId = this.$route.query.gameId;
    }
    this.searchCondition.mdztIsValid = false;
    // console.log("searchCondition.mdztIsValid::", this.searchCondition.mdztIsValid);
  },
  mounted() {
    this.queryAllSupplierList();
    this.queryCardTypeList();

    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
    if (storeCode === '42010216070190' || storeCode === '53010017032439') {
      let res = this.$store.dispatch("queryDkMicroStoreList");
      if (res) {
        res.then((r) => {
          if (r.result) {
            r.result.filter(v=>{
              if (v.shopId != "直营店" && v.shopId != "加盟店" ) {
                this.dkShops.push(v);
              }
            })
          }
        });
      }
    } else {
      this.queryShopList();
    }
    this.$store.dispatch("querySalesChannels");
    // this.queryListShopK();
    if (this.$route.query.receiptSn || this.$route.query.gameId) {
      this.queryList();
    }
    this.getReceiptSn();
  },
  methods: {
    // 限制选择时间日期范围
    checkRange(value) {
      let newDate = value[1] - value[0];
      if ( newDate > 180 * 24 * 60 * 60 * 1000) {
        this.$message.error('选择的日期范围不能超过6个月！');
        // 重置为初始值，或者根据需求设置为其他合理的值
        this.searchCondition.applyDate = [];
      }else {
        value[0] = timestampToDate(value[0]);
        value[1] = timestampToDate(value[1]);
        this.searchCondition.applyDate =[value[0],value[1]];
        // console.log(this.searchCondition.applyDate);
      }
     
    },
    cancelOrder(v) {
      let that = this
      // console.log('当前订单',v, this.searchCondition.orderState)
      this.$confirm("确定取消此订单吗？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          // console.log("ok");
          const items = {
            orderId: v.orderId,
            realname: v.realname,
            storeCode: v.storeCode
          };
          const arr = [];
          arr.push(items);
          that.$store.dispatch("cancelOrder", items).then((res) => {
            const { code, result } = res;
            if (code === "0") {
              console.log('取消订单参数',result)
              that.search();
            }
          });
        })
        .catch(() => {
          console.log("捞");
          that.search()
        });
    },
    changeMdzt(e) {
      // console.log("change:", e);
    },
    select(selection) {
      if (selection.length > 1) {
        let del_row = selection.shift()
        this.$refs.brandTable.toggleRowSelection(del_row, false)
      }
    },
    selectAll(selection){
      if (selection.length > 1) {
        selection.length = 1
      }
    },
    handleSelectionChange(row) {
      this.checkedRow = row;
    },
    pagings(page) {
      this.currentPage = page;
      this.queryListShopK();
    },
    handleSizeChanges(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryListShopK();
    },
    searchs () {
      this.currentPage = 1;
      this.queryShopLists();
    },
    inputChange() {
      this.selectAllGoods = true;
      this.newSearchCondition.salesState = '';
      this.newSearchCondition.wxshopCategoryId = '';
      this.newSearchCondition.attributeId = '';
      this.newSearchCondition.wxshopParentCategoryId = '';

      this.queryListShopK();
    },
    closeChangeGood(){
      this.exchangeGoodWindow = false;
      if(this.exchangeForm.wxshopSkuId !== ""){
        this.commitChangeGood();
        return false;
      }else{
        this.$message('请选择换货商品');
      }

    },
    handleCurrentChange(row) {
      this.checkedCurrentRow = row;
    },
    closeSelectGoods(){
      this.selectAllGoods = false;
      this.exchangeGoodName = this.checkedRow[0].wxshopSpuName;
      this.exchangeGoodGG = this.checkedRow[0].specIdGroupName;
      this.exchangeForm.changeWxshopSkuId = this.checkedRow[0].wxshopSkuId;
    },
    async commitChangeGood(){
      let prams = JSON.parse(JSON.stringify(this.exchangeForm));;
      const { result } = await this.$store.dispatch("exchangegood",prams);
      let secce = result;
      if (secce == "success"){
        this.$message('申请成功');
      }
    },
    async exchangeGoodes(val){
      // console.log(val.changeStatus);
      this.exchangeGoodWindow = true;
      this.exchangeForm.receiptSn = val.receiptSn;
      this.exchangeForm.wxshopSkuId = val.skuId;
      this.exchangeForm.changeGoodsName = val.spuName;
      this.exchangeForm.changeGoodsNum = val.goodsNum;
      this.exchangeForm.orderDetailId = val.orderDetailsId;
      this.exchangeForm.expressDetailId = val.expressDetailId;
      this.exchangeForm.goodsSn = val.goodsSn;
    },
    async queryShopLists(){
      let params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize
      };
      // console.log(this.searchConditions)
      const searchConditions = JSON.parse(JSON.stringify(this.searchConditions));
      Object.assign(params, searchConditions);
      // console.log(params)
      const { result } = await this.$store.dispatch("queryWxshopList",params);
      const { records, total } = result;
      this.selectGoodsTableData = records;
      this.total = total;
    },
    async orderDetail(row) {
      this.logisticsInfoVisible = true;

      // if (row.orderState === "deliverOrder") {
      const { code, result } = await this.$store.dispatch("showLogsistics", {
        orderId: row.orderId
      });
      if (code === "0") {
        if (result.courierInfo.state === "400") {
          this.$nextTick(() => {
            this.$message({
              message: result.courierInfo.message,
              type: "warning"
            });
          });
        }
        result.courierInfo.traces.reverse();
        result.courierInfo.traces.reverse();
        this.showLogsistics = result;
      }
      // }
    },
    sureArrive() {
      this.$store
        .dispatch("sureArrive", {
          orderId: this.row.orderId
        })
        .then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
            this.details();
          }
        });
    },
    openSendDialog() {
      this.dialogVisible = false;
      this.$router.push({
        name: "ShippingOrderList"
      });
    },
    openSendDialog2(receiptSn,mode,purchaseTime) {
      this.dialogVisible = false;
      let expressSendMode;
      if(mode){
        expressSendMode = 'third'
      }else{
        expressSendMode = 'self'
      }
      this.$router.push({
        name: "ShippingOrderList",
        query: {
          receiptSn: receiptSn,
          expressSendMode: expressSendMode,
          purchaseTime: JSON.stringify(purchaseTime),
        }
      });
    },
    async designate() {
      const result = await this.$confirm(
        "更换订单所属门店将会同时更换该订单下所有的发货单发货门店，加盟店和直营店订单不能互转，请确认无误后再操作!",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      );
      if (result === "confirm") {
        let params = {
          receiptSn: this.row.receiptSn,
          orderId: this.row.orderId,
          belongShopId: this.belongShopId,
          oldShopId: this.orderDetails.belongShopId
        };
        const { code } = await this.$store.dispatch("assignOrderShop", params);
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.belongShopId = "";
          this.queryList();
          this.details();
        }
      }
    },

    remarkFocus(row) {
      this.goodsRow = JSON.parse(JSON.stringify(row));
    },
    async remarkBlur(row) {
    // if (row.remark !== "" && row.remark !== null) {
      if (this.goodsRow.operMemo !== row.operMemo) {
        const { code } = await this.$store.dispatch("editGoodsExpressOrderDetailsRemark", {
          expressDetailId:row.expressDetailId,
          operMemo : row.operMemo
      });
        if (code === "0") {
          this.queryList();
        }
      }
      // }
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.spuId);
    },
    getCheckedReturn(selection) {
      this.returnGoods = selection;
    },
    refund(row) {
      this.dialogRetrun = true;
      this.returnGoods = [row];
    },
    getRowSpan() {
      this.rowSpanArr = [];
      this.orderGoods.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.orderGoods[index].expressQueryId ==
            this.orderGoods[index - 1].expressQueryId
          ) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.orderGoods[index].expressQueryId = this.orderGoods[
              index - 1
            ].expressQueryId;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 只合并区域位置
      if (columnIndex === 10) {
        const _row = this.rowSpanArr[rowIndex];

        return {
          rowspan: _row, //行
          colspan: 1 //列
        };
      }
    },
    async queryAllSupplierList() {
      let params = {
        pageNo: 1,
        pageSize: 99999
      };

      const { result } = await this.$store.dispatch(
        "queryAllSupplierInfoList",
        params
      );
      const { records } = result;
      this.supplierList = records;
    },
    queryCardTypeList() {
      this.$store.dispatch("queryVipCardTypeList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    async queryList() {

      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        gameId: this.searchCondition.gameId ? this.searchCondition.gameId : "",
        receiptSn: this.searchCondition.receiptSn
          ? this.searchCondition.receiptSn
          : ""
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.queryTimeValueStart = this.isArray(
        searchCondition.applyDate
      )
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.queryTimeValueEnd = this.isArray(
        searchCondition.applyDate
      )
        ? searchCondition.applyDate[1]
        : "";
      searchCondition.categoryId = this.isArray(searchCondition.categoryId)
        ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
        : searchCondition.categoryId;
      searchCondition.mdztIsValid = !searchCondition.mdztIsValid;
      Object.assign(params, searchCondition);
      if (
        this.isArray(searchCondition.applyDate) ||
        searchCondition.querySnValue !== ""
      ) {
        this.setParamsCookie();

        const { result } = await this.$store.dispatch(
          "queryNewOrderList",
          params
        );
        this.orNum = result;
        // this.globalOrderStatus.changeStatus = result.records.changeStatus
        // this.globalOrderStatus.refundReturnType = result.records.orderState
        const {
          actuallyPrice,
          payPrice,
          storeOrderBasicInfoModelPage
        } = result;
        this.payPrice = payPrice;
        this.actuallyPrice = actuallyPrice;
        this.list = storeOrderBasicInfoModelPage.records;
        this.list.map(o=>{
            o.isMessageJson = false;
            o.expressModelList[0].goodsList.forEach(v=>{
            if(v.messageJson !== null)
              {
                JSON.parse(v.messageJson).forEach(p=>{
                  if(p.messageContent!=''){
                    o.isMessageJson = true;
                  }
                })
              }
            })
            //付款时间大于90天就显示更改线下已退款订单状态按钮
            if(o.payTime && this.dateDiff(o.payTime)>90){
               o.isShowOfflineOrderRefund = true;
            }
             if (o.joinType == 'join') {
                o.shopName = '加盟店-' + o.shopName
              } else if (o.joinType == 'self') {
                 o.shopName = '直营店-' + o.shopName
             }
        })
        // console.log("this.list:",this.list);
        this.total = storeOrderBasicInfoModelPage.total;
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    reset() {
      this.searchCondition = {
        querySnType: "receiptSn",
        queryGoodsType: "spuName",
        queryMemberType: "memberMobile",
        queryTimeType: "purchaseTime",
        timeStatus: "daifahuo"
      };
    },
    selectQuerySnType(val) {
      if (val === "receiptSn") {
        this.placeholderSnType = "请输入订单号";
      } else if (val === "deliverSn") {
        this.placeholderSnType = "请输入发货单号";
      } else if (val === "spuName") {
        this.placeholderGoodsType = "请输入商品名称";
      } else if (val === "goodsSn") {
        this.placeholderGoodsType = "请输入商品货号";
      } else if (val === "barCode") {
        this.placeholderGoodsType = "请输入商品条码";
      } else if (val === "memberName") {
        this.placeholderMemberType = "请输入会员名称";
      } else if (val === "memberMobile") {
        this.placeholderMemberType = "请输入会员电话";
      }
    },
    isBtn(code) {
      return this.isShowBtn(code);
    },
    editDeliveryInfo(row, typeDelivery) {
      this.editType = "deliveryInfo";
      this.typeDelivery = typeDelivery;
      for (let key in this.ruleFormReset) {
        this.ruleFormReset[key] = row[key];
      }
      this.dialogResetForm = true;
    },
    async submitForm() {
      const valid = await this.$refs.ruleFormReset.validate();
      if (valid) {
        let params = this.ruleFormReset;
        params.editType = this.editType;

        const { code } = await this.$store.dispatch("editRemark", params);
        if (code === "0") {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.dialogResetForm = false;
          if (this.typeDelivery === "detail") {
            this.details();
          } else {
            this.queryList();
          }
        }
      }
    },
    async details() {
      const res = await this.$store.dispatch("queryOrderDetails", {
        orderId: this.row.orderId
      });
      this.orderDetails = res.result.order;
      this.orderGoods = [];
      res.result.orderGoods.forEach(v => {
        this.orderGoods.push(...v.goodsList);
      });
      this.orderStatus = res.result.orderStatus;
      this.shopOperateLogModelList = res.result.shopOperateLogModelList;
      let orderSta = res.result.orderStatus[res.result.orderStatus.length - 1];
      let flag = false;
      let spuTypeFlag = false;
      this.orderGoods.forEach(v => {
        if (v.spuType !== "virtual") {
          spuTypeFlag = true;
        }
      });
      if (!spuTypeFlag) {
        this.orderDetails.orderSpuType = "virtual";
      }
      res.result.orderGoods.map(v => {
        if (v.returnType === "no") {
          flag = true;
        }
      });
      if (flag) {
        let listStatus = [];
        res.result.orderStatus.forEach(v => {
          if (v.orderStatus !== "returnOrder") {
            listStatus.push(v);
          }
        });
        orderSta = listStatus[listStatus.length - 1];
      }

      if (orderSta.orderStatus === "createOrder") {
        this.active = 1;
        this.delOrder = true;
        this.disabled = true;
        this.delivery = true;
        this.orderSta = "待付款";
      } else if (orderSta.orderStatus === "payOrder") {
        this.active = 2;
        this.delOrder = true;
        this.disabled = false;
        this.delivery = true;
        this.orderSta = "待发货";
      } else if (orderSta.orderStatus === "deliverOrder") {
        this.active = 3;
        this.delOrder = true;
        this.orderSta = "已发货";
        this.delivery = false;
        this.disabled = true;
      } else if (orderSta.orderStatus === "takeOrder") {
        this.active = 4;
        this.delOrder = true;
        this.orderSta = "已收货";
        this.delivery = true;
        this.disabled = true;
      } else if (orderSta.orderStatus === "pushOrder") {
        this.active = 5;
        this.delOrder = true;
        this.orderSta = "已评价";
        this.delivery = true;
        this.disabled = true;
      } else if (orderSta.orderStatus === "delOrder") {
        this.delOrder = false;
        this.orderSta = "已取消";
      } else if (orderSta.orderStatus === "returnOrder") {
        this.delOrder = false;
        this.orderSta = "有退货退款";
      } else if (orderSta.orderStatus === "over3month_order_oa_approval"){
        this.delOrder = false;
        this.orderSta = "有退货退款";
      }

      res.result.orderStatus.forEach(v => {
        if (v.orderStatus === "createOrder") {
          this.createOrderTime = v.createTime;
        }
        if (v.orderStatus === "payOrder") {
          this.payOrderTime = v.createTime;
        }
        if (v.orderStatus === "deliverOrder") {
          this.deliverOrderTime = v.createTime;
        }
        if (v.orderStatus === "takeOrder") {
          this.takeOrderTime = v.createTime;
        }
        if (v.orderStatus === "pushOrder") {
          this.pushOrderTime = v.createTime;
        }
      });
      let returnDeliver = 0;
      let returnPackage = 0;
      res.result.orderGoods.forEach(v => {
        returnDeliver += v.returnDeliverMoney || 0;
        returnPackage += v.returnPackageMoney || 0;
      });
      this.useReturnDeliverMoney = (
        res.result.order.deliverMoney -
        returnDeliver -
        res.result.order.deliverCouponMoney
      ).toFixed(2);
      this.useReturnPackageMoney = (
        res.result.order.packageMoney -
        returnPackage
      ).toFixed(2);
      this.ruleFormRetrun.returnDeliverMoney = this.useReturnDeliverMoney;
      this.ruleFormRetrun.returnPackageMoney = this.useReturnPackageMoney;
      this.queryShopList();
      this.getRowSpan();
    },
    resetRetrunForm() {
      setTimeout(() => {
        this.$refs.ruleFormRetrun.resetFields();
      }, 0);
    },
    returnClose() {
      this.dialogRetrun = false;
      this.returnGoods = [];
      this.resetRetrunForm();
    },
    async againSubmitReturn() {
      await this.$store.dispatch("orderReturnPut", {
        orderRefundInfoModelList: this.orderRefundInfoModelList,
        ignoreCoupon: true
      });
      this.$message({
        message: "操作成功",
        type: "success"
      });
      this.resetRetrunForm();
      this.returnGoods = [];
      this.orderRefundInfoModelList = [];
      this.couponUsedList = [];
      this.innerVisible = false;
      this.dialogRetrun = false;
      this.details();
      this.queryList();
    },
    async submitReturn() {
      const valid = await this.$refs.ruleFormRetrun.validate();
      if (valid) {
        let params = this.ruleFormRetrun;
        params.confirmReturnDeliverMoney = params.returnDeliverMoney;
        let returnList = [];
        this.returnGoods = arrayUnique2(this.returnGoods, "skuId");
        this.returnGoods.forEach((v, i) => {
          if (i === 0) {
            returnList.push(
              Object.assign(params, {
                receiptSn: v.receiptSn,
                skuId: v.skuId,
                orderGoodsId: v.orderDetailsId,
                returnTranslate: "门店退货"
              })
            );
          } else {
            let param = {};
            for (let key in params) {
              if (
                key !== "confirmReturnDeliverMoney" &&
                key !== "returnDeliverMoney" &&
                key !== "returnPackageMoney"
              ) {
                param[key] = params[key];
              }
            }
            returnList.push(
              Object.assign(param, {
                receiptSn: v.receiptSn,
                skuId: v.skuId,
                orderGoodsId: v.orderDetailsId,
                returnTranslate: "门店退货"
              })
            );
          }
        });
        this.orderRefundInfoModelList = returnList;
        const { inMsg, result } = await this.$store.dispatch("orderReturnPut", {
          orderRefundInfoModelList: returnList,
          ignoreCoupon: false
        });
        if (inMsg === "COUPON_USED") {
          this.innerVisible = true;
          this.couponUsedList = result;
        } else {
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.resetRetrunForm();
          this.returnGoods = [];
          this.orderRefundInfoModelList = [];
          this.dialogRetrun = false;
          this.details();
          this.queryList();
        }
      }
    },
    checkSelectable(row) {
      // if (row.spuType === "virtual" && row.memberLaunchRefund !== "yes") {
      //   return false;
      // } else {
      //   return row.returnType === "no";
      // }
      let returnState = true;
      if(this.orderSta === "待付款" || this.orderSta === "已取消")
      {
        returnState = false;
      }else{
        if( row.returnType === "no"){
          returnState = true;
        }else{
          returnState = false;
        }
      }
      return returnState;
    },
    tableRowClassName({ row }) {
      if (row.returnType !== "no") {
        return "tuikuan";
      }
      return "";
    },
    batchReturn() {
      if (this.returnGoods.length) {
        this.dialogRetrun = true;
      } else {
        this.$message({
          message: "请选择退款商品",
          type: "warning"
        });
      }
    },
    toDetails(row) {
      this.row = row;
      this.belongShopId = "";
      this.details().then(() => {
        this.dialogVisible = true;
      });
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    async queryShopList() {
      const { result } = await this.$store.dispatch("queryShopList", {
        pageNo: 1,
        pageSize: 99999
      });
      console.log(result, '数据门店');
      if (result.records.length > 0) {
        this.shopListJoinType = result.records.map(item => {
          if (item.joinType == 'join') {
            return { ...item, shopName: '加盟店-' + item.shopName };
          } else if (item.joinType == 'self') {
            return { ...item, shopName: '直营店-' + item.shopName };
          }
          return item;
        });
      }
    },
    setParamsCookie() {
      setCookie({
        key: "orderListParamsNew",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "orderListParamsNew", type: "session" });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    close() {
      this.dialogVisible = false;

      this.resetRuleForm();
    },
    queryAllDetailList() {
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      searchCondition.starTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[0]
        : "";
      searchCondition.endTime = this.isArray(searchCondition.applyDate)
        ? searchCondition.applyDate[1]
        : "";
      searchCondition.pageSize = 9999999;
      searchCondition.pageNo = 1;
      return this.$store.dispatch("detailOrderList", searchCondition);
    },
    outputDetailOrder() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllDetailList()
          .then(res => {
            const list = res.result.records;

            list.forEach(v => {
              // if (v.orderType === "wshop") {
              //   v.orderType = "微店订单";
              // } else if (v.orderType === "ptdd") {
              //   v.orderType = "拼团订单";
              // } else if (v.orderType === "kjdd") {
              //   v.orderType = "砍价订单";
              // } else if (v.orderType === "mshd") {
              //   v.orderType = "秒杀订单";
              // }
              // if (v.orderSource === "wxShop") {
              //   v.orderSource = "微信";
              // }
              if (v.payMode === "no_pay") {
                v.payMode = "未支付";
              } else if (v.payMode === "wx_pay") {
                v.payMode = "微信支付";
              } else if (v.payMode === "ali_pay") {
                v.payMode = "支付支付";
              } else if (v.payMode === "0_pay") {
                v.payMode = "0元订单";
              }

              // if (v.deliveryType === "mdzt") {
              //   v.deliveryType = "门店自提";
              // } else if (v.deliveryType === "kdfh") {
              //   v.deliveryType = "快递发货";
              // } else if (v.deliveryType === "tcps") {
              //   v.deliveryType = "同城配送";
              // }
              if (v.orderState === "createOrder") {
                v.orderStatus = "待付款";
              } else if (v.orderState === "payOrder") {
                v.orderStatus = "待发货";
              } else if (v.orderState === "deliverOrder") {
                v.orderStatus = "已发货";
              } else if (v.orderState === "takeOrder") {
                v.orderStatus = "已收货";
              } else if (v.orderState === "pushOrder") {
                v.orderStatus = "同城配送";
              } else if (v.orderState === "delOrder") {
                v.orderStatus = "已取消";
              } else if (v.orderState === "returnOrder") {
                v.orderStatus = "售后订单";
              }
            });
            const tHeader = [
              "订单号",
              "分类名称",
              "品牌名称",
              "商品名称",
              "商品货号",
              "商品规格",
              "商品条码",
              "商品数量",
              "商品原价",
              "商品折后单价",
              "商品折后总价",
              "下单时间",
              "收货人",
              "收货人手机",
              "收货区域",
              "收货人地址",
              "会员手机",
              "支付状态",
              "订单状态",
              "订单总价实付金额",
              "推荐人id",
              "推荐人手机号",
              "推荐人姓名",
              "推荐人所属机构",
              "订单指定门店",
              "商品退货进度",
              "退货金额",
              "订单备注"
            ];
            const filterVal = [
              "receiptSn",
              "categoryName",
              "brandName",
              "spuName",
              "goodsSn",
              "specIdGroupName",
              "barCode",
              "goodsNum",
              "totalPrice",
              "realPrice",
              "realTotalPrice",
              "createTime",
              "receiverName",
              "receiverMobile",
              "deliveryProvince",
              "deliveryAddress",
              "memberPhone",
              "payMode",
              "orderState",
              "actuallyPrice",
              "referId",
              "memberMobile",
              "memberName",
              "departName",
              "shopName",
              "returnType",
              "returnPrice",
              "orderRemark"
            ];
            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              "订单明细" + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    outputDetail() {
      if (this.isArray(this.searchCondition.applyDate)) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.queryTimeValueStart = this.isArray(
          searchCondition.applyDate
        )
          ? searchCondition.applyDate[0]
          : "";
        searchCondition.queryTimeValueEnd = this.isArray(
          searchCondition.applyDate
        )
          ? searchCondition.applyDate[1]
          : "";
        searchCondition.categoryId = this.isArray(searchCondition.categoryId)
          ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
          : searchCondition.categoryId;
        // Object.assign(params, searchCondition);
        this.$store.dispatch("exportOrderDetailsList", searchCondition);
        setTimeout(() => {
          this.$message({
            message: "已加入导出队列正在生成报表，请在导出列队中查看！",
            type: "success"
          });
          this.hidden = false;
        }, 0);
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    outputDetailPlus() {
      if (this.isArray(this.searchCondition.applyDate)) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.queryTimeValueStart = this.isArray(
          searchCondition.applyDate
        )
          ? searchCondition.applyDate[0]
          : "";
        searchCondition.queryTimeValueEnd = this.isArray(
          searchCondition.applyDate
        )
          ? searchCondition.applyDate[1]
          : "";
        searchCondition.categoryId = this.isArray(searchCondition.categoryId)
          ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
          : searchCondition.categoryId;
        this.$store.dispatch("exportOrderDetailsListPlus", searchCondition);
        setTimeout(() => {
          this.$message({
            message: "已加入导出队列正在生成报表，请在导出列队中查看！",
            type: "success"
          });
          this.hidden = false;
        }, 0);
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    output() {
      if (this.isArray(this.searchCondition.applyDate)) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.queryTimeValueStart = this.isArray(
          searchCondition.applyDate
        )
          ? searchCondition.applyDate[0]
          : "";
        searchCondition.queryTimeValueEnd = this.isArray(
          searchCondition.applyDate
        )
          ? searchCondition.applyDate[1]
          : "";
        searchCondition.categoryId = this.isArray(searchCondition.categoryId)
          ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
          : searchCondition.categoryId;
        // Object.assign(params, searchCondition);
        this.$store.dispatch("exportOrderList", searchCondition);
        setTimeout(() => {
          this.$message({
            message: "已加入导出队列正在生成报表，请在导出列队中查看！",
            type: "success"
          });
          this.hidden = false;
        }, 0);
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    outputPlus() {
      if (this.isArray(this.searchCondition.applyDate)) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.queryTimeValueStart = this.isArray(
          searchCondition.applyDate
        )
          ? searchCondition.applyDate[0]
          : "";
        searchCondition.queryTimeValueEnd = this.isArray(
          searchCondition.applyDate
        )
          ? searchCondition.applyDate[1]
          : "";
        searchCondition.categoryId = this.isArray(searchCondition.categoryId)
          ? searchCondition.categoryId[searchCondition.categoryId.length - 1]
          : searchCondition.categoryId;
        this.$store.dispatch("exportOrderListPlus", searchCondition);
        setTimeout(() => {
          this.$message({
            message: "已加入导出队列正在生成报表，请在导出列队中查看！",
            type: "success"
          });
          this.hidden = false;
        }, 0);
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    resetRuleForm() {
      setTimeout(() => {
        this.createOrderTime = "";
        this.payOrderTime = "";
        this.deliverOrderTime = "";
        this.takeOrderTime = "";
        this.pushOrderTime = "";
        this.belongShopId = "";
        // this.ruleForm.cancelMsg = "";
      }, 0);
    },
    searchShop() {
      this.currentPage = 1;
      this.queryListShopK();
    },
    async queryListShopK(queryAll){
      const params = {
        pageSize: queryAll ? 99999 : this.pageSize,
        pageNo: this.currentPage
        // salesState: "up"
      };
      const searchCondition = JSON.parse(JSON.stringify(this.newSearchCondition));
      searchCondition.wxshopCategoryId = this.isArray(
              searchCondition.wxshopCategoryId
      )
              ? searchCondition.wxshopCategoryId[
              searchCondition.wxshopCategoryId.length - 1
                      ]
              : searchCondition.wxshopCategoryId;

      searchCondition.attributeId = this.isArray(searchCondition.attributeId)
              ? searchCondition.attributeId[searchCondition.attributeId.length - 1]
              : "";
      Object.assign(params, searchCondition);

      const { result } = await this.$store.dispatch("queryWxshopList", params);
      const { records, total } = result;
      this.listShop = records;
      this.total = total;x
    },
    saveGoods() {
      if (this.radio) {
        this.$emit("setLink", this.checkedCurrentRow);
      } else {
        this.$emit("saveGoods", this.checkedRow);
      }
    },
    async getReceiptSn() {
      const { result } = await this.$store.dispatch("getReceiptSn");
      this.receiptSnHtml = result;
    },
    // 正在上传
    uploading() {
      this.isSaving = true;
      this.uploadShow = true;
    },
    beforeUpload(file) {
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning"
        });
      }
      if (!limitSize) {
        this.$message({
          message: "上传模板大小不能超过 1M!",
          type: "warning"
        });
      }
      return (extension || extension2 || extension3 || extension4) && limitSize;
    },
    uploadMainPicSucc(jsonData) {
      if (jsonData.code === 0) {
        this.ruleFormOfflineOrderRefund.pic = jsonData.result;
        this.uploadShow = false;
      }
    },
    // 移除上传文件
    handleRemove() {
      this.ruleFormOfflineOrderRefund.pic = "";
    },
    // 提交
    async submitFormOfflineOrderRefund(formName){
          const result = await this.$confirm(
            "请核实当前的订单是否正确，您是否上传了线下退款凭证，确认无误后再操作！",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            }
          );
          if (result === "confirm") {
            this.$refs[formName].validate(valid => {
            if (valid) {
              let operateMemo = JSON.stringify(this.ruleFormOfflineOrderRefund);
              let prams = {
                operateType: "over3month_order_oa_approval",
                operateColumnValue: this.receiptSnRow,
                operateMemo: operateMemo,
              }
              // console.log("prams:",prams);
              // return false;
              this.$store.dispatch("saveOperateMemo",prams).then(res => {
                if (res.code === "0") {
                  this.$message({
                    message: "操作成功",
                    type: "success"
                  });
                  this.dialogOfflineOrderRefund = false;
                  this.queryList();
                }
              });
            }
          })
      }
    },
    offlineOrderRefund(v) {
      this.receiptSnRow = v.receiptSn;
      this.queryOperateMemo();
      this.dialogOfflineOrderRefund = true;
    },
    dateDiff(setDay) {
      //sDate1和sDate2是2006-12-18格式
      let aDate, oDate1, oDate2, iDays;
      aDate = setDay.split(" ")[0].split("-"); //调用Date的构造函数，转换为12-18-2006格式
      oDate1 = new Date(aDate[0], aDate[1] - 1, aDate[2]);
      let nowDate = new Date();
      let date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate()
      };
      if (date.month >= 1 && date.month <= 9) {
        date.month = "0" + date.month;
      }
      if (date.date >= 0 && date.date <= 9) {
        date.date = "0" + date.date;
      }
      oDate2 = oDate2 = new Date(date.year, date.month - 1, date.date); //把相差的毫秒数转换为天数
      iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24);
      return iDays;
    },
    queryOperateMemo(){
      this.ruleFormOfflineOrderRefund = {
        pic: "",
        remark: "",
      };
      this.operateTimeOfflineOrderRefund = "";
      this.operateNameOfflineOrderRefund = "";
      this.disabledRemark = false;
      let prams = {
            operateType: "over3month_order_oa_approval",
            operateColumnValue: this.receiptSnRow,
          }
      this.$store.dispatch("queryOperateMemo",prams).then(res => {
        if (res.code === "0" && res.result.records && res.result.records.length) {
          this.ruleFormOfflineOrderRefund = JSON.parse(res.result.records[0].operateMemo);
          this.operateTimeOfflineOrderRefund = res.result.records[0].operateTime;
          this.operateNameOfflineOrderRefund = res.result.records[0].operateName;
          this.disabledRemark = true;
        }
      });
    },
  }
};
</script>
<style lang="scss">
.remark-tarea {
  .el-textarea__inner {
    height: 100%;
    border: 1px solid #56abee;
  }
}
.time-type {
  .el-input__inner {
    border-right: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    color: #909399;
    background-color: rgb(245, 247, 250);
  }
}
.time {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}
.page-component__scroll {
  height: 100%;
}
.page-component__scroll .el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
<style lang="scss" scoped>
.track-rcol {
  .track-list {
    position: relative;
  }
  ul li {
    list-style: none;
    font-size: 14px;
    line-height: 14px;
  }
  ul {
    padding-left: 1.5rem;
  }
  .track-list li {
    position: relative;
    padding: 0px 0 1.5rem 25px;
    line-height: 14px;
    border-left: 1px solid #d9d9d9;
    color: #999;
  }
  .track-list li.first {
    color: red;
    padding-top: 0;
    // width: 100%;
    text-align: left;
    border-left: 1px solid #d9d9d9;
  }
  .track-list li .node-icon {
    position: absolute;
    left: -5.5px;
    border-radius: 0.25rem;
    width: 0.5rem;
    height: 0.5rem;
    top: 4px;
    background-color: #999999;
  }
  .track-list li.first .node-icon {
    background-position: 0-72px;
    background-color: red;
    width: 10px;
    z-index: 2;
    height: 10px;
    position: absolute;
    left: -5px;
    top: 0;
    border-radius: 0.5rem;
  }
  .track-list li .time {
    // margin-right: 20px;
    position: relative;
    top: 4px;
    display: inline-block;
    vertical-align: middle;
    background-color: white;
    color: #999;
    width: 100%;
    text-align: left;
  }
  .track-list li .txt {
    position: relative;
    display: inline-block;
    vertical-align: top;
    color: #999;
  }
  .track-list li.first .time {
    text-align: left;
    width: 94%;
    color: red;
  }
  .track-list li.first .txt {
    color: red;
    text-align: left;
    width: 94%;
  }
  .track-list li.finall {
    position: relative;
    padding: 0px 0 1.5rem 25px;
    line-height: 18px;
    border-color: white;
    border-left: 1px solid #ffffff;
    color: #999;
  }
  .track-list li.finall .div-spilander {
    width: 1px;
    position: absolute;
    position: absolute;
    left: -1.5px;
    height: 0.5rem;
    background-color: #d9d9d9;
  }
}
.table-only-tuikuan {
  opacity: 0.7;
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1;
}
.only-tuikuan {
  opacity: 0.3;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
}

.warning-tuikuan {
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}
.threeLine {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  line-height: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.info-list {
  padding: 0 20px;
}
.info-list,
.logistics-list {
  .title {
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 10px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.content {
  margin: -20px;
  .progress {
    background: #f7f7f7;
    padding: 20px 0;
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .goods-info {
    width: 300px;
  }
  .table-p10 {
    > div {
      padding: 10px;
    }
  }
  .table-header {
    background: #f7f7f7;
    font-weight: 700;
    font-size: 14px;
    > div {
      // padding: 10px;
      color: #222;
      border-right: 1px solid #ddd;
    }
  }
  .order-bder {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
  }

  .bd-right {
    box-sizing: border-box;
    border-right: 1px solid #ddd;
  }
  .bd-bottom {
    border-bottom: 1px solid #ddd;
  }
  .order-info {
    background: #ffe8f2;
    height: 35px;
    padding: 0 10px;
  }
  .table-body {
    // border-top: 1px solid #ddd;
    .bd-goodsinfo {
      > div {
        // padding: 10px;
        border-right: 1px solid #ddd;
      }
      border-bottom: 1px solid #ddd;
    }
    .bd-goodsinfo div:last-child {
      border-bottom: 0;
    }
    // > div {
    //   // padding: 10px;
    //   border-right: 1px solid #ddd;
    // }
  }
  .table-bodys {
    > div {
      padding: 10px;
      border-right: 1px solid #ddd;
    }
  }

  .not-bder div:last-child {
    border-right: 0;
  }
}
.empty {
  width: 100%;
  box-sizing: border-box;
  padding-top: 20px;
  .empty_tex {
    font-size: 18px;
    color: #666666;
    height: 40px;
    line-height: 40px;
    margin-bottom: 20px;
    padding: 0;
  }
}
.priview {
  position: relative;
  width: 360px;
  height: 180px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  .image {
    width: 100%;
    height: 100%;
  }
  .video {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.el-form-item{
  &.mb10{
    margin-bottom: 10px;
  }
}
</style>
